import { moduleNames } from "data/enums/modules";
import {
  enumPermissionModules as EPM,
  enumPermissions as EP,
} from "../enums/authorization";
import { type } from "@testing-library/user-event/dist/type";

const enumTranslations = {
  offersPayouts: {
    user: 'Users',
    offer: 'Offers'
  },
  usersType: {
    1: "Internal",
    2: "External",
    default: "Unknown",
  },
  trafficType: {
    "facebook": "Facebook",
    "google": "Google",
    "native": "Native",
    "push": "Push",
    "other": "Other",
    default: "Unknown"
  },

  booleanEnum: {
    true: "Yes",
    false: "No",
    default: "No",
  },

  booleanYesNo: {
    default: "No",
    yes: "Yes",
    no: "No",
  },
  changeLogChangeGroup: {
    1: "General",
    2: "Admin",
    3: "Affiliate",
    4: "Advertiser",
    default: "Unknown",
  },
  changeLogType: {
    1: "Improvement",
    2: "Bug fix",
    3: "New feature",
    default: "Unknown",
  },
  domainsStatus: {
    1: "Active",
    2: "Test Mode",
    3: "Inactive",
    4: "Suspended",
    default: "N/A",
  },
  domainsType: {
    1: "Tracking",
    default: "N/A",
  },
  status: {
    1: "Success",
    2: "Error",
    default: "N/A",
  },
  device: {
    desktop: "Desktop",
    mobile: "Mobile",
    tablet: "Tablet",
    default: "N/A",
  },
  boolean: {
    default: "No",
    true: "Yes",
    false: "No",
  },
  offersStatus: {
    1: "Active",
    2: "Test Mode",
    3: "Inactive",
    4: "Suspended",
    default: "N/A",
  },
  offersType: {
    "fixed-amount": "Fixed amount",
    "percentage": "Percentage",
    default: "N/A"
  },
  offersLimitType: {
    default: "N/A",
    "daily": "Daily",
    "weekly": "Weekly",
    "hourly": "Hourly",
    "unlimited": "Unlimited",
  },
  subscriptionsStatus: {
    1: "Active",
    2: "Suspended",
    3: "Expired",
    9: "Deleted",
    default: "N/A",
  },
  subsDescription: {
    subscription: "Subscription",
    paid_content: "Paid content",
    default: "N/A",
  },
  subscriptionsParts: {
    1: "Hold",
    2: "Paid"
  },
  offersAccess: {
    regular: "Regular",
    vip: "Vip",
    test: "Test",
    private: "Private",
    dev: "Dev",
    default: "N/A",
  },
  offersPaidStatus: {
    1: "Save from affiliate",
    2: "Send to advertiser",
    3: "Hold",
    4: "Confirmed",
    5: "Cancelled",
    6: "Trash",
    7: "Unknown",
    8: "Buyout approved",
    9: "Buyout hold",
    10: "Buyout rejected",
    default: "N/A",
  },
  offersPaidStatusLimited: {
    3: "Hold",
    4: "Confirmed",
    default: "N/A",
  },
  offersDeviceType: {
    1: "Mobile",
    2: "Desktop",
    default: "N/A",
  },
  offersCategory: {
    1: "Leadgen",
    2: "eCommerce",
    3: "Mobile Content",
    4: "App Installs",
    default: "N/A",
  },
  offersVertical1: {
    1: "Software",
    2: "Casino",
    3: "Forex",
    4: "Dating",
    5: "Sweepstakes",
    6: "Finance/Loans",
    7: "Gaming",
    8: "Social",
    9: "Shopping",
    10: "Entertainment",
    11: "SmartLink",
    12: "Crypto",
    13: "Betting",
    14: "Cams",
    15: "Lottery",
    16: "Binary Options",
    default: "N/A",
  },
  offersFlow1: {
    1: 'SOI',
    2: 'DOI',
    3: 'IVR',
    4: 'CPS',
    5: 'Hybrid',
    default: "N/A",
  },
  offersVertical2: {
    default: "N/A",
    1: 'Sex Toys',
    2: 'Fungus',
    3: 'Correctors',
    4: 'Cholesterol',
    5: 'Health & Beauty',
    6: 'Hair',
    7: 'Immunity',
    8: 'Prostatitis',
    9: 'Eyesight',
    10: 'Hypertension',
    11: 'Breast Enlargement',
    12: 'Bones',
    13: 'Muscle',
    14: 'Diabetes',
    15: 'Skin Immunity',
    16: 'Fertility Problems',
    17: 'Beauty',
    18: 'Acne',
    19: 'Joints',
    20: 'Health Products',
    21: 'Potency',
    22: 'Accessories',
    23: 'Kitchen',
    24: 'Home & Garden',
    25: 'Video Games',
    26: 'Kids Toys',
    27: 'Hemorrhoids',
    28: 'Weight Loss',
    29: 'Varicose',
    30: 'Parasites',
    31: 'CBD',
    32: 'Cystitis',
    33: 'Cellulite',
    34: 'Male Enlargement',
    35: 'Vision',
    36: 'Lungs',
    37: 'Brain boosters',
    38: 'Teeth',
    39: 'Esoteric',
    40: 'Psoriasis',
    41: 'Hair removal',
    42: 'Snoring',
    43: 'Liver',
    44: 'Smoking addiction',
    45: 'Alcohol addiction',
    46: 'Gastritis',
    47: 'Female Libido',
    48: "Kidney",
    49: "Adult Entertainment",
    50: "Hearing",
    51: "Wrinkles",
    52: "Anti-Age",
    53: "Neuropathy"
  },

  offersFlow2: {
    1: "CPL",
    2: "COD",
    3: "CPS",
    4: "Rev Share",
    default: "N/A",
  },
  offersVertical3: {
    1: "VOD",
    2: "Gaming",
    3: "Antivirus / Security",
    4: "Generic Download",
    5: "Dating",
    default: "N/A",
  },
  offersFlow3: {
    1: "Pin Submit",
    2: "DCB- Other",
    3: "DCB - 1 - Click",
    default: "N/A",
  },
  offersVertical4: {
    1: "Shopping",
    2: "Games",
    3: "Travel",
    4: "Casino",
    default: "N/A",
  },
  offersFlow4: {
    1: "Install & Open",
    2: "Registration",
    3: "Sale",
    default: "N/A",
  },
  offersFavorite: {
    true: "Favorite",
    false: "Not favorite",
    default: "Not favorite",
  },
  offersAccessStatus: {
    1: "Pending",
    2: "Approved",
    3: "Rejected",
    default: "N/A",
  },
  offerPayoutsTable: {
    offers: "Offers",
    users: "Users",
    default: "N/A",
  },
  guaranteesLogsTable: {
    user: "User",
    offer: "Offer",
  },
  reportsVertical: {
    default: "N/A",
    'Sex Toys': 'Sex Toys',
    'Fungus': 'Fungus',
    'Correctors': 'Correctors',
    'Cholesterol': 'Cholesterol',
    'Health & Beauty': 'Health & Beauty',
    'Hair': 'Hair',
    'Immunity': 'Immunity',
    'Prostatitis': 'Prostatitis',
    'Eyesight': 'Eyesight',
    'Hypertension': 'Hypertension',
    'Breast Enlargement': 'Breast Enlargement',
    'Bones': 'Bones',
    'Muscle': 'Muscle',
    'Diabetes': 'Diabetes',
    'Skin Immunity': 'Skin Immunity',
    'Fertility Problems': 'Fertility Problems',
    'Beauty': 'Beauty',
    'Acne': 'Acne',
    'Joints': 'Joints',
    'Health Products': 'Health Products',
    'Potency': 'Potency',
    'Accessories': 'Accessories',
    'Kitchen': 'Kitchen',
    'Home & Garden': 'Home & Garden',
    'Video Games': 'Video Games',
    'Kids Toys': 'Kids Toys',
    'Hemorrhoids': 'Hemorrhoids',
    'Weight Loss': 'Weight Loss',
    'Varicose': 'Varicose',
    'Parasites': 'Parasites',
    'CBD': 'CBD',
    'Cystitis': 'Cystitis',
    'Cellulite': 'Cellulite',
    'Male Enlargement': 'Male Enlargement',
    'Vision': 'Vision',
    'Lungs': 'Lungs',
    'Brain boosters': 'Brain boosters',
    'Teeth': 'Teeth',
    'Esoteric': 'Esoteric',
    'Psoriasis': 'Psoriasis',
    'Hair removal': 'Hair removal',
    'Snoring': 'Snoring',
    'Liver': 'Liver',
    'Smoking addiction': 'Smoking addiction',
    'Alcohol addiction': 'Alcohol addiction',
    'Gastritis': 'Gastritis',
    'Female Libido': 'Female Libido',
    'Kidney': 'Kidney',
    'Adult Entertainment': 'Adult Entertainment',
    'Hearing': 'Hearing',
    'Wrinkles': 'Wrinkles',
    'Anti-Age': 'Anti-Age',
    'Neuropathy': 'Neuropathy',
  },
  reportsCategory: {
    default: "N/A",
    "Leadgen": "Leadgen",
    "eCommerce": "eCommerce",
    "Mobile Content": "Mobile Content",
    "App Installs": "App Installs",
  },
  usersGUaranteesStatus: {
    inactive: "Inactive",
    active: "Active",
    default: "N/A",
  },
  trackingLinksStatus: {
    1: "Active",
    2: "Suspended",
    3: "Unknown",
    9: "Deleted",
  },
  usersStatus: {
    1: "Admin",
    2: "Account Manager",
    3: "Advertiser",
    4: "Affiliate",
    5: "Support",
    6: "Finance",
    99: "Banned",
    default: "Unknown",
  },
  prelandingsCategory: {
    1: "Test Category",
    default: "N/A",
  },
  prelandingsStatus: {
    1: "Active",
    2: "Inactive",
    3: "N/A",
  },
  prelandingStatus: {
    1: "Active",
    2: "Inactive",
    default: "N/A",
  },
  landingStatus: {
    1: "Active",
    2: "Inactive",
    default: "N/A",
  },
  landingCategory: {
    1: "Test Category",
    default: "N/A",
  },
  paymentsMethod: {
    default: "N/A",
    wire: "Wire",
    paypal: "Paypal",
    tipalti: "Tipalti",
    "usdt-erc20": "USDT ERC20",
    "usdt-trc20": "USDT TRC20",
    webmoney: "Web Money",
    "capitalist-internal": "Capitalist Internal Payment",
  },
  paymentsStatus: {
    1: "Created",
    2: "Approved",
    3: "Rejected",
    4: "Paid",
    5: "Returned",
    default: "N/A",
  },
  paymentSettings: {
    active: "Active",
    inactive: "Inactive",
    default: "N/A",
    suspended: "Suspended",
  },
  paymentSettingsAddStatus: {
    active: "Active",
    inactive: "Inactive",
    default: "N/A",
  },
  ordersStatus: {
    1: "Save from affiliate",
    2: "Send to advertiser",
    3: "Hold",
    4: "Confirmed",
    5: "Cancelled",
    6: "Trash",
    7: "Unknown",
    8: "Buyout approved",
    9: "Buyout hold",
    10: "Buyout rejected",
    11: "Error",
    default: "N/A",
  },
  guaranteesLogsStatus: {
    "hold": "Hold",
    "cancelled": "Cancelled",
    "trash": "Trash",
    "confirmed": "Confirmed",
    "unknown": "Unknown",
    default: "N/A",
  },
  orderStatusLimited: {
    1: "Save from affiliate",
    2: "Send to advertiser",
    3: "Hold",
    4: "Confirmed",
    5: "Cancelled",
    6: "Trash",
    7: "Unknown",
    default: "N/A",
  },


  loginHistoryStatus: {
    1: "Success",
    2: "Error",
    default: "N/A",
  },

  loginHistoryDevice: {
    desktop: "Desktop",
    mobile: "Mobile",
    tablet: "tablet",
    default: "N/A",
  },
  ordersErrorsStatus: {
    default: "N/A",
    not_resolved: "Not resolved",
    resolved: "Resolved",
  },
  logsQueueEmailStatus: {
    default: "N/A",
    0: "Wait for process",
    1: "Done",
    2: "Failed",
  },
  postbackStatus: {
    default: "N/A",
    1: "Active",
    2: "Inactive",
  },
  postbackType: {
    default: "N/A",
    1: "Lead",
    2: "Event",
  },
  postbackLevel: {
    default: "N/A",
    1: "Global",
    2: "Specific",
  },
  postbacksEventStandard: {
    default: "N/A",
    3: "Hold",
    4: "Confirmed",
    5: "Cancelled",
    6: "Trash",
  },
  postbacksMethod: {
    default: "N/A",
    1: "S2S",
  },
  postbacksMethodTemp: {
    default: "N/A",
    1: "S2S",
  },
  postbackLogsStatus: {
    default: "N/A",
    success: "Success",
    error: "Error",
  },
  httpCodeStatus: {
    default: "N/A",
    0: "0 Resposne not received",
    200: "200 OK",
    202: "202 Accepted",
    203: "203 Non-Authoritative Information",
    204: "204 No Content",
    205: "205 Reset Content",
    206: "206 Partial Content",
    300: "300 Multiple Choice",
    301: "301 Moved permanently",
    302: "302 Found",
    303: "303 See Other",
    304: "304 Not modified",
    307: "307 Temporary Redirect",
    308: "308 Permament Redirect",
    400: "400 Bad Request",
    401: "401 Unathorized",
    403: "403 Forbidden",
    405: "405 Method Not Allowed",
    406: "406 Not Acceptable",
    407: "407 Proxy Authentication Required",
    408: "408 Request Timeout",
    409: "409 Conflict",
    410: "410 Gone",
    411: "411 Length Required",
    412: "412 Precondition Failed",
    413: "412 Payload Too Large",
    414: "414 Uri Too Long",
    415: "415 Unsupported Media Type",
    416: "416 Range Not Satisfiable",
    417: "417 Expectation Failed",
    426: "426 Upgrade Required",
    428: "428 Precondition Required",
    429: "429 Too Many Requests",
    431: "431 Request Header Fields Too Large",
    500: "500 Internal Server Error",
    501: "501 Not Implemented",
    502: "502 Bad Gateway",
    503: "503 Service Unavailable",
    504: "504 Gateway Timeout",
    505: "505 HTTP Version Not Supported",
    510: "510 Not Extended",
    511: "511 Network Authentication Required",
  },
  statsBasedOn: {
    offer: "Offer",
    date: "Date",
    month: "Month",
    day_of_week: "Day of week",
    time: "Time",
    hour_of_day: "Hour of day",
    landings: "Landings",
    prelandings: "Prelandings",
    country_code: "Country",
    sub_1: "Sub 1",
    sub_2: "Sub 2",
    sub_3: "Sub 3",
    sub_4: "Sub 4",
    utm_campaign: "UTM campaign",
    utm_source: "UTM source",
    utm_medium: "UTM medium",
    utm_term: "UTM term",
    utm_content: "UTM content",
    device_type: "Device type",
    browser_name: "Browser name",
    browser_version: "Browser version",
    os_name: "OS name",
    os_version: "OS version",
  },
  newsStatus: {
    default: "N/A",
    unpublished: "Unpublished",
    published: "Published",
    draft: "Draft",
  },
  newsCategory: {
    default: "N/A",
    1: "General",
    2: "Payouts",
    3: "New offers",
    4: "New geos",
    5: 'Offers STOP',
    6: 'Offers Renew',
    7: 'Special offer'
  },
  newsAutomaticDeletionAfter: {
    default: "N/A",
    'never': "Never",
    86400: "1 day",
    604800: "1 week",
    1209600: "2 weeks",
    2592000: "1 month",
  }
};

const commonTableFilters = {
  filter: "Filters",
  search: "Search filters",
  filterTypes: {
    dateRange: {
      label: "Date range",
      helperText: "Value represents server date",
      invalidRange: ": invalid range",
      maxDate: ": max date exceeded",
      minDate: ": min date exceeded",
    },
    selectStaticMultiple: {
      placeholder: "Select",
      noOptionsText: "No available options",
      select: "Select",
      noCategory: "Please select a category",
    },
    selectStaticSingle: {
      placeholder: "Select",
      noOptionsText: "No available options",
    },
    countrySelect: {
      placeholder: "Select country",
    },
    selectAjaxMultiple: {
      text: "No available options",
      placeholder: "Search",
      loading: "Loading",
    },
  },
  sortAsc: "Sort column ascending",
  sortDesc: "Sort column descending",
  hideColumn: "Hide column",
  clearStickyColumn: "Clear sticky column",
  setStickyColumn: "Set sticky column",
  clearStickyRow: "Clear sticky row",
  setStickyRow: "Set sticky row",
  noData: "No data",
  pinColumnLeft: "Pin column left",
  pinColumnRight: "Pin column right",
  unpinColumn: "Unpin column",
  toggleChartVisibility: "Toggle chart visibility",
  clearFilters: "Clear filters",
  collapseFilters: "Collapse filters",
  expandFilters: "Expand filters",
  tableView: "Table view",
  chartView: "Chart view",
  saveFilters: "Save filters",
  saveFiltersAsBookmark: "Save views as a bookmark",
  pleaseEnterANameForBookmark: "Please enter a name for your bookmark",
  cancel: "Cancel",
  save: "Save",
  filtersSaved: "Filters saved!"
};

const commonModalTranslations = {
  saveView: "Save view",
  tabs: {
    required: "Required*",
    affectedRows: "Affected Rows",
    info: "Info",
    target: "Target",
    advertiser: "Advertiser",
    overrides: "Overrides",
    newRecord: "New record",
    payments: "Payments",
    company: "Company",
  },
  footer: {
    reset: "Reset",
    cancel: "Cancel",
    submit: "Submit",
    confirm: "Confirm",
    delete: "Delete",
  },
  body: {
    warning: "This action can not be undone!",
    question: "Are you sure you want to delete ",
    approveQuestion: "Are you sure you want to confirm payment for ",
    noItems: "No items selected for bulk delete",
    noItemsAdd: "No items selected for bulk add",
    isLoading: "Deleting",
    isSuccess: "Successfully deleted",
    isError: "Error during delete",
    itemSelected: "Item selected for bulk delete",
    itemSelectedEdit: "Item selected for bulk edit",
    sendingUpdate: "Sending update",
    seccessfullyUpdated: "Successfully updated",
    isErrorEdit: "Error during update",
    required: "required",
    name: {
      label: "Name",
      placeholder: "Enter name for param",
    },
    value: {
      label: "Value",
      placeholder: "Enter value for param",
    },
    deleteParam: "Delete param",
  },
  filepond: {
    labelIdle:
      "Drag & Drop your files or <span class='filepond--label-action'> Browse </span>",
    labelInvalidField: "Field contains invalid files",
    labelFileProcessing: "Uploading",
    labelFileRemoveError: "Error during remove'",
    labelFileLoadError: "Error during load",
    labelTapToCancel: "tap to cancel",
    labelFileProcessingComplete: "Upload complete",
    labelFileProcessingAborted: "Upload cancelled",
    labelButtonProcessItem: "Upload",
    labelButtonRetryItemProcessing: "Retry",
    labelButtonAbortItemProcessing: "Cancel",
    labelButtonUndoItemProcessing: "Undo",
    labelTapToUndo: "tap to undo",
    labelFileLoading: "Loading",
  },
  formBuilder: {
    reset: 'Reset styles',
    generateUrl: 'Generate URL',
    generatedMessage: 'Generated URL',
    form: 'Form',
    formCustomization: 'Select element',
    inputs: 'Inputs',
    inputsCustomization: 'Customize inputs',
    text: 'Text',
    priceTitle: 'Title',
    oldPrice: 'Old price',
    price: 'Current price',
    textAlign: 'Align text',
    flex: 'Layout direction',
    justifyContent: 'Justify content',
    alignItems: 'Align items',
    gap: 'Gap',
    width: 'Width',
    backgroundColor: 'Background color',
    borderWidth: 'Border width',
    borderColor: 'Border color',
    borderRadius: 'Border radius',
    fontSize: 'Font size',
    fontWeight: 'Font weight',
    light: 'Light',
    normal: 'Normal',
    bold: 'Bold',
    padding: 'Padding',
    margin: 'Margin',
    textColor: 'Text color',
    enableCountry: 'Enable country select',
    enableQuantity: 'Enable quantity',
    namePlaceholder: 'Enter text for name input',
    phonePlaceholder: 'Enter text for phone input',
    countryPlaceholder: 'Enter text for country select',
    quantityPlaceholder: 'Enter text for quantity input',
    enableMockup: 'Enable mockup',
    enablePrice: 'Enable price',
    quantityLeftPlaceholder: 'Eg. There is only {quantity} left',
    numberInputLabel: 'Quantity',

  }
};

const profileServerFieldErrors = {
  8: {
    password: "Password must be between 12 and 128 characters.",
    repeated_password: "Passwords do not match.",
    "info.pin": "PIN must be exactly 4 digits.",
    "info.repeat_pin": "PINs do not match.",
  },
};

const commonTableTranslations = {
  of: 'of',
  drawer: {
    savedFilterBookmarks: "Saved views",
    noBookmarksAdded: "No views added",
    toAddAFiltersBookmark: "To add a view, click on 'Save view' below",
    saveCurrentView: "Save current view"
  },
  header: {
    filters: "Filters",
    sortAsc: "Sort ascending",
    sortDesc: "Sort descending",
    all: "All",
    refreshData: "Refresh data",
    columnsEditor: "Columns editor",
    visualLayers: "Visual layers",
    emptySpace: "Fill table empty space",
    bulkOptions: "Bulk options",
    orderColumns: "Select or reorder table columns",
    enable: "Enable auto fill on screen resize",
    disable: "Disable auto fill on screen resize",
    downloadTableData: "Download table data",
    tableView: "Table view",
    chartView: "Chart view",
    emptySpaceOptions: {
      fillEmptySpace: "Fill empty space",
      enableAutoFill: "Enable auto fill on screen resize",
      disableAutoFill: "Disable auto fill on screen resize",
    },
    savedFilters: "Saved views",
    columnsSaved: "Columns saved!"
  },
  body: {
    pinRow: "Pin row",
    cards: {
      created: "Created",
      approved: "Approved",
      rejected: "Rejected",
      paid: "Paid",
      return: "Return",
    },
    noData: "No data",
  },
  modale: {
    columnsEditorTitle: "Select or reorder table columns",
  },
};

const GB = {
  modalFieldsErrors: {
    required: "Required",
    minimum: (minChar) => `minimum ${minChar} characters`,
    maximum: (maxChar) => `maximum ${maxChar} characters`,
    min: (min) => `minimum allowed value is ${min}`,
    max: (max) => `maximum allowed value is ${max}`,
    email: "Invalid format",
    domain: "Invalid format (http/https)://domain.com)",
    fieldsDontMatch: (matchFieldLabel) =>
      `fields do not match ${matchFieldLabel}`,
  },

  MenuSegment: {
    admin: "Admin",
    affiliate: "Affiliate",
    advertiser: "Advertiser",
    user: "User",
    system: "System",
    dev: "Dev",
  },
  MenuLink: {
    [moduleNames.ADMIN_DASHBOARD]: "Dashboard",
    [moduleNames.ADMIN_REPORT_DROPDOWN]: "Report",
    [moduleNames.ADMIN_REPORT_BALANCE]: "Balance",
    [moduleNames.ADMIN_REPORT_OFFERS]: "Offers",
    [moduleNames.ADMIN_REPORT_USERS]: "Affiliates",
    [moduleNames.ADMIN_REPORT_ADVERTISERS]: "Advertisers",
    [moduleNames.ADMIN_REPORT_COUNTRIES]: "Countries",
    [moduleNames.ADMIN_REPORT_DYNAMICS]: "Dynamic",
    [moduleNames.ADMIN_REPORT_ORDERS]: "Orders",
    [moduleNames.ADMIN_USERS_DROPDOWN]: "Users",
    [moduleNames.ADMIN_USERS]: "All Users",
    [moduleNames.ADMIN_USERS_UNAPPROVED]: "Unapproved",
    [moduleNames.ADMIN_DOMAINS]: "Domains",
    [moduleNames.ADMIN_NEWS]: "News",
    [moduleNames.ADMIN_OFFERS_DROPDOWN]: "Offers",
    [moduleNames.ADMIN_OFFERS]: "List",
    [moduleNames.ADMIN_OFFERS_SUBSCRIPTIONS]: "Subscriptions",
    [moduleNames.ADMIN_OFFERS_ACCESS]: "Access",
    [moduleNames.ADMIN_OFFERS_BLACKLIST_USERS]: "Blacklist users",
    [moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS]: "Payouts",
    [moduleNames.ADMIN_OFFERS_TRACKING_LINKS]: "Tracking links",
    [moduleNames.ADMIN_OFFERS_USERS_GUARANTEES]: "User Guarantees",
    [moduleNames.ADMIN_GUARANTEES_DROPDOWN]: "Guarantees",
    [moduleNames.ADMIN_GUARANTEES_LOGS]: "Logs",
    [moduleNames.ADMIN_PAGES_DROPDOWN]: "Pages",
    [moduleNames.ADMIN_LANDINGS]: "Landings",
    [moduleNames.ADMIN_LOGIN_HISTORY]: "Login History",
    [moduleNames.ADMIN_BALANCE]: "Balance",
    [moduleNames.ADMIN_LOGS_DROPDOWN]: "Logs",
    [moduleNames.ADMIN_LOGS_QUEUE_EMAIL]: "Queue Email",
    [moduleNames.ADMIN_PRELANDINGS]: "Prelandings",
    [moduleNames.ADMIN_PAYMENTS]: "Payments",
    [moduleNames.ADMIN_ORDERS_DROPDOWN]: "Orders",
    [moduleNames.ADMIN_ORDERS]: "List",
    [moduleNames.ADMIN_ORDERS_ERRORS]: "Errors",
    [moduleNames.ADMIN_TOPUPS]: "Topups",
    [moduleNames.ADMIN_POSTBACK_LOGS]: "Postback Logs",
    [moduleNames.ADMIN_PROFILE]: "Profile",
    [moduleNames.ADMIN_CHANGELOG]: "Change log",
    [moduleNames.ADMIN_FAQ]: "FAQ",
    [`${moduleNames.DEV_BUILDER_DROPDOWN}_admin`]: "Builder",
    [`${moduleNames.DEV_BUILDER_MODULE}_admin`]: "Module",

    //Affiliate modules
    [moduleNames.AFFILIATE_DASHBOARD]: "Dashboard",
    [moduleNames.AFFILIATE_REPORT]: "Report",
    [moduleNames.AFFILIATE_DOMAINS]: "Domains",
    [moduleNames.AFFILIATE_OFFERS_DROPDOWN]: "Offers",
    [moduleNames.AFFILIATE_OFFERS_SUBSCRIPTIONS]: "Subscriptions",
    [moduleNames.AFFILIATE_OFFERS_ALL]: "All",
    [moduleNames.AFFILIATE_OFFERS_HOT]: "Hot",
    [moduleNames.AFFILIATE_OFFERS]: "Offers",
    [moduleNames.AFFILIATE_LOGIN_HISTORY]: "Login History",
    [moduleNames.AFFILIATE_PROFILE]: "Profile",
    [moduleNames.AFFILIATE_ORDERS_DROPDOWN]: "Orders",
    [moduleNames.AFFILIATE_ORDERS]: "List",
    [moduleNames.AFFILIATE_PAYMENTS]: "Payments",
    [moduleNames.AFFILIATE_PAYMENTS_REQUEST]: "Request",
    [moduleNames.AFFILIATE_PAYMENTS_SETTINGS]: "Settings",
    [moduleNames.AFFILIATE_BALANCE]: "Balance",
    [moduleNames.AFFILIATE_REFERRAL]: "Referral",
    [moduleNames.AFFILIATE_REFERRAL_STATS]: "Referral Stats",
    [moduleNames.AFFILIATE_LOGIN_HISTORY]: "Login History",
    [moduleNames.AFFILIATE_POSTBACK_DROPDOWN]: "Postback",
    [moduleNames.AFFILIATE_POSTBACK]: "Settings",
    [moduleNames.AFFILIATE_POSTBACK_LOGS]: "Logs",
    [moduleNames.AFFILIATE_FAQ]: 'FAQ',
    [`${moduleNames.DEV_BUILDER_DROPDOWN}_aff`]: "Builder",
    [`${moduleNames.DEV_BUILDER_MODULE}_aff`]: "Module",

    //Advertiser modules
    [moduleNames.ADVERTISER_DASHBOARD]: "Dashboard",
    [moduleNames.ADVERTISER_OFFERS]: "Offers",
    [moduleNames.ADVERTISER_ORDERS]: "Orders",
    [moduleNames.ADVERTISER_TOPUPS]: "Topups",
    [moduleNames.ADVERTISER_LOGIN_HISTORY]: "Login History",
    [moduleNames.ADVERTISER_PROFILE]: "Profile",
    [moduleNames.ADVERTISER_FAQ]: 'FAQ',
    [`${moduleNames.DEV_BUILDER_DROPDOWN}_adv`]: "Builder",
    [`${moduleNames.DEV_BUILDER_MODULE}_adv`]: "Module",
  },
  PermissionsModalBody: {
    admin: "Admin",
    // Admin - Dashboard
    [EPM.ADMIN_DASHBOARD]: "Dashboard",
    [EP.ADMIN_DASHBOARD_ANALYTICS]: "Analytics",
    // Admin - Report
    [EPM.ADMIN_REPORT]: "Report",
    [EP.ADMIN_REPORT_BALANCE]: "Balance",
    [EP.ADMIN_REPORT_OFFERS]: "Offers",
    [EP.ADMIN_REPORT_USERS]: "Users",
    [EP.ADMIN_REPORT_ADVERTISERS]: "Advertisers",
    [EP.ADMIN_REPORT_COUNTRIES]: "Countries",
    [EP.ADMIN_REPORT_DYNAMICS]: "Dynamic",
    [EP.ADMIN_REPORT_ORDERS]: "Orders",
    // Admin - Users
    [EPM.ADMIN_USERS]: "Users",
    [EP.ADMIN_USERS_LIST]: "List",
    [EP.ADMIN_USERS_GET]: "Get",
    [EP.ADMIN_USERS_CREATE]: "Create",
    [EP.ADMIN_USERS_UPDATE]: "Update",
    [EP.ADMIN_USERS_UPDATE_EMAIL]: "Update email",
    [EP.ADMIN_USERS_DELETE]: "Delete",

    // Admin - Permissions
    [EPM.ADMIN_PERMISSIONS]: "Permission",
    [EP.ADMIN_PERMISSIONS_GET]: "Get",
    [EP.ADMIN_PERMISSIONS_UPDATE]: "Update",
    // Admin - Users unapproved
    [EPM.ADMIN_USERS_UNAPPROVED]: "Users unapproved",
    [EP.ADMIN_USERS_UNAPPROVED_LIST]: "List",
    [EP.ADMIN_USERS_UNAPPROVED_APPROVED]: "Approve",
    [EP.ADMIN_USERS_UNAPPROVED_REJECT]: "Reject",
    [EP.ADMIN_USERS_UNAPPROVED_SET_MANAGER]: "Set manager",
    [EP.ADMIN_USERS_UNAPPROVED_RESET_MANAGER]: "Reset manager",
    [EP.ADMIN_USERS_UNAPPROVED_TOTAL]: "Total",

    // Admin - Offers
    [EPM.ADMIN_OFFERS]: "Offers",
    [EP.ADMIN_OFFERS_LIST]: "List",
    [EP.ADMIN_OFFERS_GET]: "Get",
    [EP.ADMIN_OFFERS_CREATE]: "Create",
    [EP.ADMIN_OFFERS_UPDATE]: "Update",
    // Admin - Offers Subscriptions
    [EPM.ADMIN_OFFERS_SUBSCRIPTIONS]: "Subscriptions",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_LIST]: "List",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_GET]: "Get",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_UPDATE]: "Update",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_APPROVE_PAYMENT]: "Approve",
    [EP.ADMIN_OFFERS_SUBSCRIPTIONS_TOTAL]: "Total",
    // Admin - Offers access
    [EPM.ADMIN_OFFERS_ACCESS]: "Offers access",
    [EP.ADMIN_OFFERS_ACCESS_LIST]: "List",
    [EP.ADMIN_OFFERS_ACCESS_CREATE]: "Create",
    [EP.ADMIN_OFFERS_ACCESS_APPROVED]: "Approve",
    [EP.ADMIN_OFFERS_ACCESS_REJECT]: "Reject",
    //Admin - Offers blacklist users
    [EPM.ADMIN_OFFERS_BLACKLIST_USERS]: "Offers blacklist users",
    [EP.ADMIN_OFFERS_BLACKLIST_USERS_LIST]: "List",
    [EP.ADMIN_OFFERS_BLACKLIST_USERS_CREATE]: "Create",
    [EP.ADMIN_OFFERS_BLACKLIST_USERS_DELETE]: "Delete",
    // Admin - Offers payout
    [EPM.ADMIN_OFFERS_PAYOUT]: "Offers payout",
    [EP.ADMIN_OFFERS_PAYOUT_LIST]: "List",
    [EP.ADMIN_OFFERS_PAYOUT_GET]: "Get",
    [EP.ADMIN_OFFERS_PAYOUT_CREATE]: "Create",
    [EP.ADMIN_OFFERS_PAYOUT_UPDATE]: "Update",
    [EP.ADMIN_OFFERS_PAYOUT_DELETE]: "Delete",
    // Admin - Tracking list
    [EPM.ADMIN_OFFERS_TRACKING_LINKS]: "Tracking links",
    [EP.ADMIN_OFFERS_TRACKING_LINKS_LIST]: "List",
    [EP.ADMIN_OFFERS_TRACKING_LINKS_CREATE]: "Create",
    [EP.ADMIN_OFFERS_TRACKING_LINKS_DELETE]: "Delete",
    // Admin - Offers user guarantees
    [EPM.ADMIN_OFFERS_USERS_GUARANTEES]: "Offers user guarantees",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_LIST]: "List",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_GET]: "Get",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_CREATE]: "Create",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_UPDATE]: "Update",
    [EP.ADMIN_OFFERS_USERS_GUARANTEES_DELETE]: "Delete",
    // Admin - Offers guarantees logs
    [EPM.ADMIN_GUARANTEES_LOGS]: "Guarantees logs",
    [EP.ADMIN_GUARANTEES_LOGS_LIST]: "List",
    [EP.ADMIN_GUARANTEES_LOGS_GET]: "Get",
    [EP.ADMIN_GUARANTEES_LOGS_CREATE]: "Create",
    [EP.ADMIN_GUARANTEES_LOGS_UPDATE]: "Update",
    [EP.ADMIN_GUARANTEES_LOGS_DELETE]: "Delete",
    // Admin - Domains
    [EPM.ADMIN_DOMAINS]: "Domains",
    [EP.ADMIN_DOMAINS_LIST]: "List",
    [EP.ADMIN_DOMAINS_GET]: "Get",
    [EP.ADMIN_DOMAINS_CREATE]: "Create",
    [EP.ADMIN_DOMAINS_UPDATE]: "Update",
    [EP.ADMIN_DOMAINS_DELETE]: "Delete",
    // Admin - Domains
    [EPM.ADMIN_NEWS]: "News",
    [EP.ADMIN_NEWS_LIST]: "List",
    [EP.ADMIN_NEWS_GET]: "Get",
    [EP.ADMIN_NEWS_CREATE]: "Create",
    [EP.ADMIN_NEWS_UPDATE]: "Update",
    [EP.ADMIN_NEWS_DELETE]: "Delete",
    // Admin - Landings
    [EPM.ADMIN_LANDINGS]: "Landings",
    [EP.ADMIN_LANDINGS_LIST]: "List",
    [EP.ADMIN_LANDINGS_GET]: "Get",
    [EP.ADMIN_LANDINGS_CREATE]: "Create",
    [EP.ADMIN_LANDINGS_UPDATE]: "Update",
    [EP.ADMIN_LANDINGS_DELETE]: "Delete",
    // Admin - Prelandings
    [EPM.ADMIN_PRELANDINGS]: "Prelandings",
    [EP.ADMIN_PRELANDINGS_LIST]: "List",
    [EP.ADMIN_PRELANDINGS_GET]: "Get",
    [EP.ADMIN_PRELANDINGS_CREATE]: "Create",
    [EP.ADMIN_PRELANDINGS_UPDATE]: "Update",
    [EP.ADMIN_PRELANDINGS_DELETE]: "Delete",
    // Admin - Balance
    [EPM.ADMIN_BALANCE]: "Balance",
    [EP.ADMIN_BALANCE_LIST]: "List",
    [EP.ADMIN_BALANCE_UPDATE]: "Update",
    [EP.ADMIN_BALANCE_DELETE]: "Delete",
    // Admin - Login History
    [EPM.ADMIN_LOGIN_HISTORY]: "Login History",
    [EP.ADMIN_LOGIN_HISTORY_LIST]: "List",
    [EP.ADMIN_LOGIN_HISTORY_GET]: "Get",
    [EP.ADMIN_LOGIN_HISTORY_DELETE]: "Delete",
    // Admin - Logs - Queue email
    [EPM.ADMIN_LOGS]: "Admin Logs",
    [EP.ADMIN_LOGS_QUEUE_EMAIL]: "Queue Email",
    // Admin - Payments
    [EPM.ADMIN_PAYMENTS]: "Payments",
    [EP.ADMIN_PAYMENTS_LIST]: "List",
    [EP.ADMIN_PAYMENTS_CREATE]: "Create",
    [EP.ADMIN_PAYMENTS_UPDATE]: "Update",
    [EP.ADMIN_PAYMENTS_TOTAL]: "Total",
    [EP.ADMIN_PAYMENTS_MASS]: "Mass Payment Request",
    // Admin - ORDERS
    [EPM.ADMIN_ORDERS]: "Orders",
    [EP.ADMIN_ORDERS_LIST]: "List",
    [EP.ADMIN_ORDERS_LOGS]: "Logs",
    [EP.ADMIN_ORDERS_COUNTER]: "Counter",
    [EP.ADMIN_ORDERS_UPDATE]: "Update",
    [EP.ADMIN_ORDERS_VIEW_PHONE]: "View phone",
    // Admin - ORDERS ERRORS
    [EPM.ADMIN_ORDERS_ERRORS]: "Orders Error",
    [EP.ADMIN_ORDERS_ERRORS_LIST]: "List",
    [EP.ADMIN_ORDERS_ERRORS_GET]: "Get",
    [EP.ADMIN_ORDERS_ERRORS_UPDATE]: "Update",
    [EP.ADMIN_ORDERS_ERRORS_DELETE]: "Delete",
    [EP.ADMIN_ORDERS_ERRORS_RESEND]: "Resend",
    [EP.ADMIN_ORDERS_ERRORS_VIEW_PHONE]: "View phone",
    // Admin - Topups
    [EPM.ADMIN_TOPUPS]: "Topups",
    [EP.ADMIN_TOPUPS_LIST]: "List",
    [EP.ADMIN_TOPUPS_GET]: "Get",
    [EP.ADMIN_TOPUPS_CREATE]: "Create",
    [EP.ADMIN_TOPUPS_UPDATE]: "Update",
    [EP.ADMIN_TOPUPS_DELETE]: "Delete",
    // Admin - Fast login
    [EPM.ADMIN_FAST_LOGIN]: "Fast login",
    [EP.ADMIN_FAST_LOGIN_CREATE]: "Create",
    [EP.ADMIN_FAST_LOGIN_CHECK]: "Check",
    //Admin - Postback Logs
    [EPM.ADMIN_POSTBACK_LOGS]: "Postback Logs",
    [EP.ADMIN_POSTBACK_LOGS_LIST]: "List",
    //Admin - Change Log
    [EPM.ADMIN_CHANGELOG]: "Change log",
    [EP.ADMIN_CHANGELOG_LIST]: "List",
    [EP.ADMIN_CHANGELOG_UPDATE]: "Update",
    [EP.ADMIN_CHANGELOG_CREATE]: "Create",
    [EP.ADMIN_CHANGELOG_DELETE]: "Delete",
    //Admin - Profile
    [EP.ADMIN_USERS_GET]: "Get",
    [EP.ADMIN_USERS_UPDATE]: "Update",
    // Admin - Country
    [EPM.ADMIN_COUNTRY]: "Country",
    [EP.ADMIN_COUNTRY_LIST]: "List",

    common: "Common",
  },
  DashboardFooter: {
    companyName: "MONETIZEAD",
    craftedLeft: "Crafted with",
    craftedRight: "by MonetizeAd",
  },
  DashboardHeader: {
    balance: { label: "Balance", tooltip: "Check profile balance" },
    manager: { label: "Manager", tooltip: "Manager info" },
    news: { label: "News", tooltip: "View news" },
    tableView: "Table view",
    gridView: "Grid view",
    balanceWidget: {
      balance: "Balance",
      paid: "Paid",
      profit: "Profit",
      total: "Total",
    },
    managerWidget: {
      name: "Name",
    },
  },
  AccountMenu: {
    profile: "Profile",
    referralLink: "Referral link",
    logout: "Logout",
    referralSuccessful: "Referral link copied successfully!",
    account_menu: "Account menu",
  },
  MonadLeadNews: {
    news: "news",
    unread: "unread",
    category: "Category",
    date: "Date added",
  },
  MenuFooter: {
    commonModalTranslations,
    mobileApp: "Mobile APP",
    qr: "Scan or click QR code to download APP",
    loginAs: "Log in as",
    logout: "Logout",
    confirm: "Confirm",
    backTo: "Back to",
  },
  Logout: {
    title: "Logout",
    loading: "Waiting to safely log out",
    completed: "You have been safely logged out",
    button: "Back to Login",
  },
  MfaRequiredBanner: {
    title: "Two-factor authentication is required",
    description: "Your account does not have MFA enabled. Set it up now to keep your account secure.",
    cta: "Set up MFA now",
  },
  Admission: {
    recaptcha_required: "Please verify that you are not a robot.",
    username_required: "Username is required",
    short_username: "Username is at least 4 characters long",
    long_username: "Username is at most 20 characters long",
    pw_required: "Password is required",
    short_pw: "Password is at least 4 characters long",
    long_pw: "Password is at most 20 characters long",
    username: "Username",
    password: "Password",
    login: "Log in",
    forgot_pw: "Forgot password?",
    welcoming: "Welcome Back",
    welcome: "Welcome",
    have_account: "Already have an account?",
    no_account: "Don't have an account?",
    sign_in: "Sign in",
    sign_up: "Sign up",
    instead: "instead",
    first_name: "First Name",
    firstname_required: "First name is required",
    long_firstname: "First name is at most 20 characters long",
    short_firstname: "First name is at least 3 characters long",
    last_name: "Last Name",
    lastname_required: "Last name is required",
    short_lastname: "Last name is at least 3 characters long",
    long_lastname: "Last name is at most 20 characters long",
    email_required: "Email is required",
    wrong_format: "Email is in wrong format",
    email: "Email",
    register: "Register",
    already_reg: "Already registered?",
    first_name_req: "First name",
    request: "Request",
    remember_password: "I remember my password",
    successful_email:
      "Successfully sent email with instructions to reset your password",
    email_already_sent:
      "A password reset email has already been sent. Please check your inbox and spam folder.",
    password_reset_required_notice:
      "For security reasons, a password change is required. This measure applies to all users — please reset your password to continue.",
    backto_login: "Back to login",
    mfa_title: "Two-factor authentication",
    mfa_description: "Enter the 6-digit code from your authenticator app to finish signing in.",
    mfa_code: "Authenticator code",
    mfa_invalid_code: "Enter a valid 6-digit code",
    mfa_verify: "Verify",
    mfa_back: "Back",
    mfa_generic_error: "Verification failed. Try again.",
    mfa_expires_in: "Code expires in {time}",
    mfa_token_expired_inline: "Code expired. Click Back to log in again.",
    mfa_session_expired: "Session expired. Please log in again.",
  },
  RequestErrors: {
    default: "Unknown error",
    browser: {
      ERR_NETWORK: "Network error",
    },
    network: {
      401: "Unauthenticated user",
      403: "Insufficient permissions",
      405: "Method not allowed",
      406: "Request not acceptable",
    },
    internal: {
      1: "The requested method is not allowed",
      2: "Login information on the system has not been forwarded",
      3: "Username is invalid format",
      4: "Password is invalid format",
      5: "Login data is invalid",
      6: "Database error",
      7: "The POST request is incorrect format",
      8: "The field is incorrect format",
      9: "The entry already exists in the database",
      10: "ID has to be passed through the GET method",
      11: "The requested ID was not found in the database",
      12: "One of the search parameters needs to be passed",
      13: "The GET parameter is invalid format",
      14: "The requested user was not found in the database",
      15: "The requested country was not found in the database",
      16: "User doesn't have permission for the requested module / action",
      17: "The mysql table name needs to be passed",
      18: "Value not found in selected database",
      19: "Error passing key / value parameters",
      20: "The file format isn't allowed",
      21: "The category was not found in the table",
      22: "The product was not found in the table",
      23: "The product ID was not passed",
      24: "The variation was not found in the table",
      25: "The selected table is not allowed to be viewed using this method",
      26: "Unable to find user. General error",
      27: "The requested number was not found, or is used in one of the campaigns",
      28: "There are no users for payout for the requested period",
      29: "Only pending payout is allowed to be deleted",
      30: "It is necessary to pass the parameter: status",
      31: "Unable to switch from existing to requested status",
      32: "The contact has been taken or is already owned by the user",
      33: "The entry has already been received in the system",
      34: "It is necessary to pass the status through the GET method",
      35: "The ticket does not exist or is closed for further response",
      36: "The user does not have an active selected payment method",
      37: "The amount you entered is not sufficient for the selected method",
      38: "The selected method is currently unavailable for use",
      39: "The selected method is currently inactive on your account",
      40: "You currently have insufficient funds in your account",
      41: "It is necessary to pass the username through the query parameter",
      42: "Unable to find user in the database",
      43: "A link to reset the password has already been requested for the user. Check your spam / junk",
      44: "Unable to find token",
      45: "You need to re-enter the password correctly",
      46: "Manager not set for the user",
      47: "This user doesn't belong to you",
      48: "This user has been accepted already",
      //49 - edited payout in cost
      49: "Advertiser cost needs to be greater than affiliate payout",
      50: "Error while sending the order to advertiser",
      51: 'Condition already created.',
      52: 'Payment method is not active',
      53: 'Value is less than allowed',
      54: 'Value is greater than allowed',
      55: 'Entered contact number is not valid.'
    },
    custom: {},
  },

  modal: {
    info: "Info",
    affectedRows: "Affected rows",
    overrides: "Overrides",
  },

  [moduleNames.ADMIN_DASHBOARD]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Dashboard",
    statistics: "Statistics",
    event: "Event",
    advertiserCost: "Advertiser Cost",
    advertiser_cost: 'Ad. cost',
    canceled: 'Canceled',
    ar: 'AR',
    country_name: "Country name",
    hold: "Hold",
    username: 'Username',
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    trash: "Trash",
    offer_name: 'Offer',
    affiliate: "Affiliate",
    affiliates: "Affiliates",
    countries: "Countries",
    no_filters: "No filters added",
    advertiser: "Advertiser",
    advertisers: "Advertisers",
    manager: "Manager",
    offers: "Offers",
    profit: "Profit",
    no_data: "No data",
    total: "Total",
    payout: "Payout",
    ad_cost: "Advertisment cost",
    approve_rate: "Approve rate",
    required: "Required*",
    referralLink: "Referral link",
    profile: "Profile",
    logout: "Logout",
    offer_id: "Offer id",
    country_code: "Country code",
    filters: {
      advertiser_id: { label: "advertiser", description: "Search by username" },
      affiliate_id: { label: "affiliate", description: "Search by username" },
      manager_id: { label: 'manager', description: "Search by username" },
      offer_id: { label: "offer", description: "Search by name" },
    },

    rangeShortcuts: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This week",
      lastWeek: "Last week",
      last7Days: "Last 7 days",
      currentMonth: "This month",
      lastMonth: "Last month",
      selectDate: "SELECT DATE RANGE",
      cancelButton: "Cancel",
      clearButton: "Clear",
      dateFrom: "Date from",
      dateTo: "End",
    },
  },
  [moduleNames.ADMIN_REPORT_BALANCE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Balance report",
    columns: {
      "info.id": "ID",
      "data.username": "Username",
      "data.balance": "Total earned",
      "data.total_withdrawn": "Total withdrawn",
      "data.rest": "Rest",
    },
    filters: {
      user_id: { label: "User", description: "Search by username" },
      manager_id: { label: "Manager", description: "Search by username" },
    },
  },
  [moduleNames.ADMIN_REPORT_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Offers report",
    columns: {
      "info.offer_id": "Offer ID",
      "data.offer_name": "Offer name",
      "data.hold": "Hold",
      "data.trash": "Trash",
      "data.canceled": "Canceled",
      "data.confirmed": "Confirmed",
      "data.total": "Total",
      "data.ar": "Approve rate",
      "data.payout": "Payout",
      "data.advertiser_cost": "Advertiser cost",
      "data.profit": "Profit",
    },
    filters: {
      affiliate_id: { label: "Aff. Id", description: "Search by Aff. Id" },
      affiliate_username: { label: "Aff. Username", description: "Search by Aff. Username" },
      affiliate_safe_id: { label: "Aff. SafeId", description: "Search by Aff. SafeId" },

      advertiser_id: { label: "Adv. Id", description: "Search by Adv. Id" },
      advertiser_username: { label: "Adv. Username", description: "Search by Adv. Username" },
      advertiser_safe_id: { label: "Adv. SafeId", description: "Search by Adv. SafeId" },

      manager_id: { label: "Manager", description: "Search by username" },
      offer_id: { label: "Offer", description: "Search by name" },
      country_code: { label: "Country" },
      date_range: { label: "Date range" },
    },
  },
  [moduleNames.ADMIN_REPORT_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Users report",
    columns: {
      "info.user_id": "User ID",
      "data.username": "Username",
      "data.hold": "Hold",
      "data.trash": "Trash",
      "data.canceled": "Canceled",
      "data.confirmed": "Confirmed",
      "data.total": "Total",
      "data.ar": "Approve rate",
      "data.payout": "Payout",
      "data.advertiser_cost": "Advertiser cost",
      "data.profit": "Profit",
    },
    filters: {
      affiliate_id: { label: "Aff. Id", description: "Search by Aff. Id" },
      affiliate_username: { label: "Aff. Username", description: "Search by Aff. Username" },
      affiliate_safe_id: { label: "Aff. SafeId", description: "Search by Aff. SafeId" },

      advertiser_id: { label: "Adv. Id", description: "Search by Adv. Id" },
      advertiser_username: { label: "Adv. Username", description: "Search by Adv. Username" },
      advertiser_safe_id: { label: "Adv. SafeId", description: "Search by Adv. SafeId" },
      offer_id: { label: "Offer", description: "Search by name" },
      country_code: { label: "Country" },
      date_range: { label: "Date range" },
      manager_id: { label: "Manager", description: "Search by username" },
    },
  },
  [moduleNames.ADMIN_REPORT_ADVERTISERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Advertisers report",
    columns: {
      "username-id": "Advertiser",
      "data.hold": "Hold",
      "data.trash": "Trash",
      "data.canceled": "Canceled",
      "data.confirmed": "Confirmed",
      "data.total": "Total",
      "data.ar": "Approve rate",
      "data.payout": "Payout",
      "data.advertiser_cost": "Advertiser cost",
      "data.profit": "Profit",
    },
    filters: {

      affiliate_id: { label: "Aff. Id", description: "Search by Aff. Id" },
      affiliate_username: { label: "Aff. Username", description: "Search by Aff. Username" },
      affiliate_safe_id: { label: "Aff. SafeId", description: "Search by Aff. SafeId" },

      advertiser_id: { label: "Adv. Id", description: "Search by Adv. Id" },
      advertiser_username: { label: "Adv. Username", description: "Search by Adv. Username" },
      advertiser_safe_id: { label: "Adv. SafeId", description: "Search by Adv. SafeId" },

      offer_id: { label: "Offer", description: "Search by name" },
      country_code: { label: "Country" },
      date_range: { label: "Date range" },
      manager_id: { label: "Manager", description: "Search by username" },
    },
  },
  [moduleNames.ADMIN_REPORT_COUNTRIES]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Countries report",
    columns: {
      "data.country_code": "Country",
      "data.hold": "Hold",
      "data.trash": "Trash",
      "data.canceled": "Canceled",
      "data.confirmed": "Confirmed",
      "data.total": "Total",
      "data.ar": "Approve rate",
      "data.payout": "Payout",
      "data.advertiser_cost": "Advertiser cost",
      "data.profit": "Profit",
    },
    filters: {

      affiliate_id: { label: "Aff. Id", description: "Search by Aff. Id" },
      affiliate_username: { label: "Aff. Username", description: "Search by Aff. Username" },
      affiliate_safe_id: { label: "Aff. SafeId", description: "Search by Aff. SafeId" },

      advertiser_id: { label: "Adv. Id", description: "Search by Adv. Id" },
      advertiser_username: { label: "Adv. Username", description: "Search by Adv. Username" },
      advertiser_safe_id: { label: "Adv. SafeId", description: "Search by Adv. SafeId" },

      offer_id: { label: "Offer", description: "Search by name" },
      country_code: { label: "Country" },
      data_range: { label: "Data range" },
      manager_id: { label: "Manager", description: "Search by username" },
    },
  },
  [moduleNames.ADMIN_REPORT_DYNAMICS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Dynamic report",
    columns: {
      date: "Date",
      affiliate: "Affiliate",
      advertiser: "Advertiser",
      manager: "Manager",
      landing_name: "Landing",
      prelanding_name: "Prelanding",
      offer_name: "Offer",
      country_code: "Country",
      sub_1: "Sub 1",
      sub_2: "Sub 2",
      sub_3: "Sub 3",
      sub_4: "Sub 4",
      device_type: "Device",
      browser_name: "Browser",
      browser_version: "Browser version",
      os_name: "OS",
      os_version: "OS version",
      total: "Total",
      hold: "Hold",
      confirmed: "Confirmed",
      trash: "Trash",
      canceled: "Canceled",
      approved_rate: "Approve rate",
      expected_ar: "Expected approve rate",
      trash_rate: "Trash rate",
      canceled_rate: "Canceled rate",
      payout: "Payout",
      advertiser_cost: "Advertiser cost",
      profit: "Profit",
      earnings_per_hold: "Earnings per hold",
      earnings_per_confirmed: "Earnings per confirmed",
      utm_source: 'UTM Source',
      utm_medium: 'UTM Medium',
      utm_campaign: 'UTM Campaign',
      utm_term: 'UTM Term',
      utm_content: 'UTM Content',
      category: 'Category',
      vertical: 'Vertical',
    },
    filters: {
      vertical: { label: "Vertical" },
      category: { label: "Category" },
      affiliate_id: { label: "Aff. Id", description: "Search by Aff. Id" },
      affiliate_username: { label: "Aff. Username", description: "Search by Aff. Username" },
      affiliate_safe_id: { label: "Aff. SafeId", description: "Search by Aff. SafeId" },

      advertiser_id: { label: "Adv. Id", description: "Search by Adv. Id" },
      advertiser_username: { label: "Adv. Username", description: "Search by Adv. Username" },
      advertiser_safe_id: { label: "Adv. SafeId", description: "Search by Adv. SafeId" },

      manager_id: { label: "Manager", description: "Search by username" },

      offer_id: { label: "Offer", description: "Search by name" },
      country_code: { label: "Country" },
      lp: { label: "Landing", description: "Search by name" },
      prelp: { label: "Prelanding", description: "Search by name" },
      sub_1: { label: "Sub 1" },
      sub_2: { label: "Sub 2" },
      sub_3: { label: "Sub 3" },
      sub_4: { label: "Sub 4" },
      utm_campaign: { label: "UTM campaign", description: "Search by UTM campaign" },
      utm_content: { label: "UTM content", description: "Search by UTM content" },
      utm_medium: { label: "UTM medium", description: "Search by UTM medium" },
      utm_source: { label: "UTM source", description: "Search by UTM source" },
      utm_term: { label: "UTM term", description: "Search by UTM term" },
      date_range: { label: "Date range" },
    },
  },
  [moduleNames.ADMIN_REPORT_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Orders report",
    editLabel: "Edit",
    logsLabel: "Logs",
    editBulkLabel: "Edit",
    editModalTitle: "Edit order",
    editModalBulkTitle: "Edit orders",
    reqResModalTitle: "Req/Res Logs",
    columns: {
      "info.id": "ID",
      name: "Name",
      phone: "Phone",
      "offer.id": "Offer ID",
      "offer.name": "Offer name",
      "advertiser.offer_id": "Advertiser Offer ID",
      "info.advertiser_id": "Advertiser ID",
      "info.advertiser_username": "Advertiser",
      "info.status": "Status",
      "info.before_status": "Before status",
      "info.affiliate_id": "Affiliate ID",
      "info.affiliate_username": "Affiliate",
      "flow.landings.id": "Landings ID",
      "flow.landings.name": "Landings name",
      "flow.prelandings.id": "Prelandings ID",
      "flow.prelandings.name": "Prelandings name",
      country_code: "Country",
      quantity: "Quantity",
      "tracking.user_ip": "User IP",
      "created.timestamp": "Created",
      base_url: "Base URL",
      referrer: "Referrer",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "OS name",
      "tracking.os_version": "OS version",
      "tracking.browser_name": "Browser name",
      "tracking.browser_version": "Browser version",
      "tracking.safe_id": "Safe ID",
      "tracking.click_id": "Click ID",
      "tracking.device_type": "Device Type",
      "tracking.external_id": "External ID",
      "tracking.utm_term": "UTM Terms",
      "tracking.utm_medium": "UTM Medium",
      "tracking.utm_source": "UTM Source",
      "tracking.utm_content": "UTM content",
      "tracking.utm_campaign": "UTM campaign",
      "info.last_update": "Last update",
      "info.counter": "Counter",
      test_mode: "Test mode",
      "advertiser_cost": "Adv. Cost",
      "affiliate_payout": "Aff. Payout",

    },
    filters: {
      id: { label: "ID" },

      affiliate_id: { label: "Aff. Id", description: "Search by Aff. Id" },
      affiliate_username: { label: "Aff. Username", description: "Search by Aff. Username" },
      affiliate_safe_id: { label: "Aff. SafeId", description: "Search by Aff. SafeId" },

      advertiser_id: { label: "Adv. Id", description: "Search by Adv. Id" },
      advertiser_username: { label: "Adv. Username", description: "Search by Adv. Username" },
      advertiser_safe_id: { label: "Adv. SafeId", description: "Search by Adv. SafeId" },

      country_code: { label: "Country", description: "Search by country name" },
      offer_id: { label: "Offer", description: "Search by offer name" },
      prelanding_id: { label: "Prelanding", description: "Search by name" },
      landing_id: { label: "Landings", description: "Search by name" },
      tracking_sub_1: { label: "Sub 1" },
      tracking_sub_2: { label: "Sub 2" },
      tracking_sub_3: { label: "Sub 3" },
      tracking_sub_4: { label: "Sub 4" },
      tracking_click_id: { label: "Tracking click ID" },
      name: { label: "Name" },
      external_id: { label: "External ID" },
      phone: { label: "Phone number" },
      status: { label: "Status" },
      date_range: { label: "Date range" },
    },
    formData: {
      country_code: { label: "Country", description: "Search by country name" },
      name: { label: "Name" },
      phone: { label: "Phone" },
      user_ip: { label: "User IP" },
      test_mode: { label: "Test mode" },
      advertiserOfferId: { label: "Advertiser Offer ID" },
      reset_counter: { label: "Reset counter" },
    },
  },

  [moduleNames.ADMIN_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Offers",
    createLabel: "Add offer",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create offer",
    editModalTitle: "Edit offer",
    editModalBulkTitle: "Edit offers",
    payourOffersLabel: "Offers payout",
    payourUsersLabel: "Users payout",
    noOptionsText: "No options. Category is required",
    copyLinkLabel: 'Copy URL',
    copyLinkSuccessMessage: 'Link copied to clipboard',
    viewOfferLabel: 'View offer',
    tabs: {
      info: "Info",
      target: "Target",
      advertiser: "Advertiser",
      overrides: "Overrides",
      affectedRows: "Affected rows",
    },
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.access": "Access",
      "data.status": "Status",
      "data.paid_status": "Paid status",
      "data.info.ar": "Approve rate",
      "data.info.cr": "Conversion rate",
      "data.info.epc": "Earn per click",
      "data.advertiser.id": "Advertiser ID",
      "data.advertiser.name": "Advertiser",
      "data.advertiser.offer_id": "Advertiser offer ID",
      "data.category.id": "Category",
      "data.advertiser.expected_ar": "Expected aprove rate",
      "data.main_country_code": "Main country",
      "data.advertiser.advertiser_guarantees": "Advertiser guarantees",
      "data.advertiser.guaranteed_ar": "Guaranteed aprove rate",
      "data.advertiser.min_orders": "Guaranteed min orders",
      "data.advertiser.timeframe": "Guaranteed timeframe",
      "data.device": "Device",
      "data.vertical": "Vertical",
      "data.region": "Region",
      "data.flow": "Flow",
      "data.monadlead_tokens": "Monadlead tokens",
      "info.affiliate_payout": "Payout",
      "info.advertiser_cost": "Cost",
      "info.price": "Price"
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      name: { label: "Name" },
      advertiser_id: { label: "Advertiser", description: "Search by username" },
      category_id: { label: "Category" },
      vertical_id: { label: "Vertical", description: 'Select category', },
      region_id: { label: "Region" },
      status: { label: "Status" },
      paid_status: { label: "Paid status" },
      main_country_code: { label: "Main country" },
      advertiser_offer_id: { label: "Advertiser Offer ID" },
      access: { label: "Access", description: 'Search by access' },

    },
    formData: {
      name: { label: "Name", placeholder: "Offer name" },
      access: { label: "Access", placeholder: "Offer access level" },
      status: { label: "Status" },
      paidStatus: { label: "Paid status" },
      mainCountry: { label: "Main country" },
      description: { label: "Description" },
      image: { label: "Image" },
      categoryId: { label: "Category" },
      vertical: { label: "Vertical" },
      flow: { label: "Flow" },
      device: { label: "Device" },
      advertiserId: { label: "Advertiser" },
      offerId: { label: "Offer" },
      expectedAr: { label: "Expected AR" },
      guaranteedAr: { label: "Guaranteed AR" },
      minOrders: { label: "Min orders" },
      timeframe: { label: "Timeframe" },
      advertiserGuarantees: { label: "Advertiser guarantees AR" },
      ar: { label: "Approve rate" },
      cr: { label: "Conversion rate" },
      epc: { label: "Earn per click" },
      tokens: { label: "MonadLead tokens" },
    },
  },
  [moduleNames.ADMIN_OFFERS_SUBSCRIPTIONS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Subscriptions",
    editLabel: "Edit",
    logsLabel: "Logs",
    editBulkLabel: "Edit",
    editModalTitle: "Edit order",
    editModalBulkTitle: "Edit orders",
    approveModalTitle: "Approve subscription payment",
    approveModalBody: "Amount that will be added to balance is",
    payments: "Payments",
    totalLabel: "Total",
    approveLabel: "Approve",
    columns: {
      id: "ID",
      "affiliate.id": "Afiliate ID",
      "affiliate.name": "Afiliate",
      "offer.id": "Offer ID",
      "offer.name": "Offer name",
      "advertiser.name": "Advertiser",
      "advertiser.id": "Advertiser ID",
      "tracking_link.name": "Tracking link",
      "tracking_link.id": "Tracking link ID",
      rev_share: "Rev share",
      subscriber: "Subscriber",
      status: "Status",
      expiration_date: "Expiration date",
    },
    filters: {
      "offer.id": { label: "Offer", description: "Search by offer" },
      "affiliate.name": { label: "Afiliate", description: "Search by afiliate name" },
      "advertiser.name": { label: "Advertiser", description: "Search by advertiser name" },
      "advertiser.id": { label: "Advertiser ID", description: "Search by advertiser id" },
      status: { label: "Status" },
    },
    formData: {
      rev_share: { label: "Rev share" },
      expiration_date: { label: "Expiration date" },
      status: { label: "Status" },
    },
  },
  [moduleNames.ADMIN_OFFERS_SUBSCRIPTIONS_PAYMENTS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Payouts",
    createLabel: "Add payout",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create payout",
    editModalTitle: "Edit payout",
    editModalBulkTitle: "Edit payouts",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete payout",
    deleteModalBulkTitle: "Delete payouts",
    columns: {
      description: 'Description',
      amount: 'Amount',
      rev_share: 'Rev share',
      status: 'Status',
    },
    filters: {
      status: { label: "Status" },
    },
    formData: {

    },
  },
  [moduleNames.ADMIN_OFFERS_BLACKLIST_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Blacklist users",
    createLabel: "Add",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Add",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete",
    deleteModalBulkTitle: "Delete",
    columns: {
      'info.id': "ID",
      'username': "Username",
      'user_id': "User ID",
      'offer_name': "Offer name",
      'offer_id': "Offer ID",
      'timestamp': "Created",
    },
    filters: {
      user_id: { label: 'User', description: 'Search by username' },
      offer_id: { label: 'Offer', description: 'Search by name' },
    },
    formData: {
      userId: { label: 'User', description: 'Search by username' },
      offerId: { label: 'Offer', description: 'Search by name' },
    }
  },
  [moduleNames.ADMIN_CHANGELOG]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Change log",
    createLabel: "Add log",
    editLabel: "Edit",
    deleteLabel: "Delete",
    editBulkLabel: "Edit",
    addModalTitle: "Create",
    editModalTitle: "Edit log",
    editModalBulkTitle: "Edit logs",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete log",
    deleteModalBulkTitle: "Delete logs",
    columns: {
      "info.id": "ID",
      "info.subject": "Subject",
      "info.change_group": "Change group",
      "info.type": "Type",
    },
    filters: {
      change_group: { label: "General" },
      type: { label: "Type" },
      subject: { label: "Subject" },
    },
    formData: {
      subject: { label: "Subject" },
      change_group: { label: "Change group" },
      type: { label: "Type" },
      text: { label: "Text" },
    },
  },
  [moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Payouts",
    createLabel: "Add record",
    createOfferLabel: "Create payout for offer",
    createUserLabel: "Create payout",
    createOfferBulkLabel: "Create payouts for offers",
    createUserBulkLabel: "Create offers payouts for users",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addOfferModalTitle: "Create payout for offer",
    addUserModalTitle: "Create offer payout",
    editOfferModalTitle: "Edit",
    editModalBulkTitle: "Edit payouts",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete payout",
    deleteModalBulkTitle: "Delete payouts",
    addOfferModalBulkTitle: "Create payouts for offers",
    addUserModalBulkTitle: "Create offers payouts",
    tabs: {
      info: "Info",
      newRecord: "New record",
    },
    columns: {
      "info.id": "ID",
      "info.offer_id": "Offer ID",
      "info.offer_name": "Offer",
      "info.username": "Username",
      "info.safe_id": "SafeID",
      "data.code": "Country",
      "data.limit": "Limit",
      "data.price": "Price",
      "data.advertiser_cost": "Advertiser cost",
      "data.affiliate_payout": "Affiliate payout",
    },
    filters: {
      table: { label: "Table" },
      user_id: { label: "User", description: "Search by username" },
      advertiser_id: { label: "Advertiser", description: "Search by username" },
      offer_id: { label: "Offer", description: "Search by name" },
      country_code: { label: "Country" },
      limit: { label: "Limit" }
    },
    formData: {
      countryCode: { label: "Country" },
      price: { label: "Price", description: "25 KM*" },
      limit: { label: "Limit" },
      limit_value: { label: "Limit value" },
      advertiserCost: { label: "Advertiser cost" },
      affiliatePayout: { label: "Affiliate payout" },
      offerId: { label: "Offer" },
      userId: { label: "User" },
      type: { label: "Type" },
      duration_days: { label: "Duration (days)" },
    },
  },
  [moduleNames.ADMIN_OFFERS_TRACKING_LINKS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Tracking links",
    createLabel: "Add",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Add",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete",
    deleteModalBulkTitle: "Delete",
    columns: {
      'id': "ID",
      'user_id': "User ID",
      'advertiser_id': "Advertiser ID",
      'name': "Name",
      'offer_name': "Offer",
      'offer_id': "Offer ID",
      'url': "URL",
      'updated_by': "Updated by",
      'updated_at': "Updated at",
      'created_by': "Created by",
      'created_at': "Created at",
      'track_subs_count': "Subs count",
      'clicks_count': 'Clicks count',
      'track_total_revenue': "Total revenue",
      'status': "Status",
    },
    filters: {
      name: { label: 'Name', description: 'Search by name' },
      status: { label: 'Status' },
    },
    formData: {
      name: { label: 'Name', description: 'Search by name' },
      userId: { label: 'User', description: 'Search by username' },
      offerId: { label: 'Offer', description: 'Search by name' },
    }
  },
  [moduleNames.ADMIN_OFFERS_PAYOUT_OFFERS_SLIDE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Payouts",
    createLabel: "Add record",
    createOfferLabel: "Create payout for offer",
    createUserLabel: "Create offer payout for user",
    createOfferBulkLabel: "Create payouts for offers",
    createUserBulkLabel: "Create offers payouts for users",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addOfferModalTitle: "Create payout for offer",
    addUserModalTitle: "Create offer payout for user",
    editOfferModalTitle: "Edit",
    editModalBulkTitle: "Edit payouts",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete payout",
    deleteModalBulkTitle: "Delete payouts",
    addOfferModalBulkTitle: "Create payouts for offers",
    addUserModalBulkTitle: "Create offers payouts for users",
    tabs: {
      info: "Info",
      newRecord: "New record",
    },
    columns: {
      "info.id": "ID",
      "info.offer_name": "Offer",
      "data.code": "Country",
      "data.limit": "Limit",
      "data.price": "Price",
      "data.advertiser_cost": "Advertiser cost",
      "data.affiliate_payout": "Affiliate payout",
    },
    filters: {
      user_id: { label: "Username" },
      country_code: { label: "Country" },
    },
    formData: {
      countryCode: { label: "Country" },
      price: { label: "Price", description: "25 KM*" },
      limit: { label: "Limit", description: "200 / hour*" },
      advertiserCost: { label: "Advertiser cost" },
      affiliatePayout: { label: "Affiliate payout" },
      offerId: { label: "Offer" },
    },
  },
  [moduleNames.ADMIN_OFFERS_PAYOUT_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Payouts",
    createLabel: "Add payout",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create payout",
    editModalTitle: "Edit payout",
    editModalBulkTitle: "Edit payouts",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete payout",
    deleteModalBulkTitle: "Delete payouts",
    columns: {
      "info.id": "ID",
      "info.offer_name": "Offer",
      "info.username": "Username",
      "data.code": "Country",
      "data.limit": "Limit",
      "data.price": "Price",
      "data.advertiser_cost": "Advertiser cost",
      "data.affiliate_payout": "Affiliate payout",
    },
    filters: {
      user_id: { label: "Username" },
      country_code: { label: "Country" },
    },
    formData: {
      countryCode: { label: "Country" },
      price: { label: "Price", description: "25 KM*" },
      limit: { label: "Limit", description: "200 / hour*" },
      advertiserCost: { label: "Advertiser cost" },
      affiliatePayout: { label: "Affiliate payout" },
      userId: { label: "User" },
    },
  },
  [moduleNames.ADMIN_OFFERS_ACCESS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Users access",
    createLabel: "Add access",
    approveLabel: "Approve",
    rejectLabel: "Reject",
    rejectBulkLabel: "Reject",
    approveBulkLabel: "Approve",
    addModalTitle: "Create access",
    rejectModalTitle: "Reject access",
    rejectModalBulkTitle: "Reject accesses",
    approveModalTitle: "Approve access",
    approveModalBody: "Are you sure you want to approve access?",
    approveModalBulk: "Are you sure you want to accept IDs?",
    columns: {
      "info.id": "ID",
      username: "Username",
      user_id: "User ID",
      offer_name: "Offer",
      offer_id: "Offer ID",
      status: "Status",
      comment: "Comment",
    },
    filters: {
      user_id: { label: "User", description: "Search by username" },
      offer_id: { label: "Offer", description: "Search by name" },
      status: { label: "Status" },
    },
    formData: {
      userId: { label: "User", description: "Search by username" },
      offerId: { label: "Offer", description: "Search by name" },
      comment: { label: "Comment" },
      rejectComment: { label: "Reject comment" },
    },
  },
  [moduleNames.ADMIN_OFFERS_USERS_GUARANTEES]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Users guarantees",
    createLabel: "Add record",
    createAddSingleLabe: "Add guarantee",
    createAddBulkLabel: "Add guarantees",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create user guarantee",
    editModalTitle: "Edit user guarantee",
    editModalBulkTitle: "Edit users guarantees",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete user guarantee",
    deleteModalBulkTitle: "Delete users guarantees",
    addModalBulkTitle: "Create users guarantees",
    columns: {
      "info.id": "ID",
      "data.user_id": "User ID",
      "info.username": "Username",
      "data.offer_id": "Offer ID",
      "info.offer_name": "Offer",
      "data.guaranteed_ar": "Guaranteed AR",
      "data.min_orders": "Min orders",
      "data.timeframe": "Timeframe",
      "data.timestamp": "Timestamp",
      "data.status": "Status",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      user_id: { label: "User ID" },
      offer_id: { label: "Offer ID" },
      status: { label: "Status" },
      username: { label: "Username" },
      offer_name: { label: "Offer name" },
      safe_id: { label: "Safe ID" }
    },
    formData: {
      user: { label: "User", description: "Search by username" },
      offer: { label: "Offer", description: "Search by name" },
      guaranteed_ar: { label: "Guaranteed AR" },
      min_orders: {
        label: "Min orders",
        description: "Number between 1 and 100",
      },
      status: { label: "Status" },
      timeframe: {
        label: "Timeframe",
        description: "Number between 1 and 365",
      },
    },
  },
  [moduleNames.ADMIN_GUARANTEES_LOGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Guarantee logs",
    createLabel: "Add record",
    createAddSingleLabe: "Add guarantee log",
    createAddBulkLabel: "Add guarantee logs",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create guarantee log",
    editModalTitle: "Edit guarantee log",
    editModalBulkTitle: "Edit guarantee logs",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete guarantee log",
    deleteModalBulkTitle: "Delete guarantee logs",
    addModalBulkTitle: "Create guarantee logs",
    columns: {
      "id": "ID",
      "user.id": "User ID",
      "user.username": "Username",
      "offer.name": "Offer",
      "offer.id": "Offer ID",
      "order_id": "Order ID",
      "data.guaranteed_ar": "Guaranteed AR",
      "from_status": "From status",
      "to_status": "To status",
      "date": "Date",
      "data.timestamp": "Timestamp",
      "payout": "Payout",
      "advertiser_cost": "Advertiser cost",
      "click_id": "Click ID",
    },
    filters: {
      table: { lablel: "Table" },
      id: { label: "ID", description: "Search by ID" },
      user_id: { label: "Affiliate", description: "Search by name " },
      offer_id: { label: "Offer", description: "Search by name" },
      order_id: { label: "Order ID" },
      from_status: { label: "From status" },
      to_status: { label: "To status" },
      date: { label: "Date" },
      click_id: { label: "Click ID" }
    },
    formData: {
      user: { label: "User", description: "Search by username" },
      offer: { label: "Offer", description: "Search by name" },
      guaranteed_ar: { label: "Guaranteed AR" },
      min_orders: {
        label: "Min orders",
        description: "Number between 1 and 100",
      },
      status: { label: "Status" },
      timeframe: {
        label: "Timeframe",
        description: "Number between 1 and 365",
      },
    },
  },
  [moduleNames.ADMIN_BALANCE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Balance",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    editModalTitle: "Edit balance",
    editModalBulkTitle: "Edit balances",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete balance",
    deleteModalBulkTitle: "Delete balances",
    columns: {
      "info.id": "ID",
      "data.affiliate": "Affiliate",
      "data.advertiser": "Advertiser",
      "data.offer_name": "Offer name",
      "data.click_id": "Click ID",
      "data.payout": "Payout",
      "data.advertiser_cost": "Advertiser Cost",
      "data.timestamp": "Timestamp",
    },
    filters: {
      user_id: { label: "Affiliate", description: "Search by user" },
      advertiser_id: { label: "Advertiser", description: "Search by username" },
      offer_id: { label: "Offer", description: "Search by offer" },
      payout: { label: "Payout", description: "Search by payout" },
      click_id: { label: "Click ID" },
    },
    formData: {
      payout: { label: "Payout" },
      advertiser_cost: { label: "Advertiser Cost" },
    },
  },
  [moduleNames.ADMIN_DOMAINS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Domains",
    createLabel: "Add domain",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create domain",
    editModalTitle: "Edit domain",
    editModalBulkTitle: "Edit domains",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete domain",
    deleteModalBulkTitle: "Delete domains",
    columns: {
      "info.id": "ID",
      "data.domain": "Domain",
      "data.status": "Status",
      "data.type": "Type",
      "info.username": "Username",
      "info.landing_name": "Landing",
      "info.prelanding_name": "Prelanding",
    },
    filters: {
      id: { label: "ID" },
      user_id: { label: "User" },
      type: { label: "Type" },
      status: { label: "Status" },
    },
    formData: {
      domain: { label: "Domain" },
      status: { label: "Status" },
      type: { label: "Type" },
    },
  },
  [moduleNames.ADMIN_LOGIN_HISTORY]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Login history",
    columns: {
      "info.id": "ID",
      ip: "IP",
      "info.username": "Username",
      country_code: "Country",
      status: "Status",
      "data.os_type": "Device",
      "data.device_type": "Device Type",
      "data.os_title": "OS Title",
      "data.browser_title": "Browser Title",
      "data.os_name": "Operating System",
      "data.os_family": "OS Family",
      "data.os_version": "OS Version",
      "data.64bits_mode": "Bits Mode",
      "data.browser_name": "Browser",
      "data.browser_version": "Browser Version",
      "data.browser_ios_webview": "Browser IOS Webview",
      "data.browser_desktop_mode": "Browser Desktop Mode",
      "data.browser_gecko_version": "Browser Gecko Version",
      "data.browser_webkit_version": "Browser Webkit Version",
      "data.browser_android_webview": "Browser Android Version",
      "data.browser_chrome_original": "Browser Chrome Original",
      "data.browser_safari_original": "Browser Safari Original",
      "data.browser_chromium_version": "Browser Chromium Version",
      "data.browser_firefox_original": "Browser Firefox Original",
      "created.timestamp": "Created time",
    },

    filters: {
      username: {
        label: "Username",
      },
    },
  },
  [moduleNames.ADMIN_NEWS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - News",
    createLabel: "Add news",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create news",
    editModalTitle: "Edit news",
    editModalBulkTitle: "Edit news",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete news",
    deleteModalBulkTitle: "Delete news",

    columns: {
      "info.id": "ID",
      "data.title": "Title",
      "data.short_description": "Description",
      "data.category": "Category",
      "data.status": "Status",
      "data.created_at": "Created at",
      "info.user_id": "User ID",
      "data.username": "Username",
      "data.popup": "Popup",
    },

    filters: {
      id: {
        label: "ID",
        placeholder: "Search by id",
      },
      user_id: {
        label: "User ID",
        placeholder: "Search by username",
      },
      category: {
        label: "Category",
      },
      status: {
        label: "Status",
      },
      popup: {
        label: "Popup",
      },
      automaticDeletionAfter: {
        label: "Automatic deletion after"
      },
    },

    formData: {
      title: {
        label: "Title",
        description: "News title",
      },
      shortDescription: {
        label: "Short description",
        placeholder: "News description",
      },
      automaticDeletionAfter: {
        label: "Automatic deletion after"
      },
      category: {
        label: "Category",
      },
      status: {
        label: "Status",
      },
      text: {
        label: "Text",
      },
      popup: {
        label: "Popup",
      },
    },
  },
  [moduleNames.ADMIN_LANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Landings",
    createLabel: "Add landing",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create landing",
    editModalTitle: "Edit landing",
    editModalBulkTitle: "Edit landings",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete landing",
    deleteModalBulkTitle: "Delete landings",
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.download": "Download URL",
      "data.redirect_url": "Redirect URL",
      "data.status": "Status",
      "data.category.id": "Category",
      "data.category_code": "Country",
      "info.offer_name": "Offer name",
      "info.offer_id": "Offer ID",
      "info.country_name": "Country name",
      "info.user_id": "User ID",
      "info.username": "Username",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      offer_id: { label: "Offer", description: "Search by name" },
      user_id: { label: "Username", description: "Search by username" },
      category_id: { label: "Category" },
      name: { label: "Name", description: "Search by name" },
      country_code: { label: "Country" },
      status: { label: "Status", description: "Search by status" },
    },
    formData: {
      offer_id: { label: "Offer" },
      name: { label: "Name" },
      category_id: { label: "Category" },
      country_code: { lable: "Country" },
      status: { label: "Status" },
      redirect_url: { label: "Redirect URL" },
      download_url: { label: "Download URL" },
      user_id: { label: "User" },
    },
  },
  [moduleNames.ADMIN_PRELANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Prelandings",
    createLabel: "Add prelanding",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create prelanding",
    editModalTitle: "Edit prelanding",
    editModalBulkTitle: "Edit prelandings",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete prelanding",
    deleteModalBulkTitle: "Delete prelandings",
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.download_url": "Download URL",
      "data.redirect_url": "Redirect URL",
      "data.status": "Status",
      "data.category.id": "Category",
      "data.category.name": "Category Name",
      "data.county_code": "Country",
      "info.offer_name": "Offer",
      "info.offer_id": "Offer ID",
      "info.country_name": "Country Name",
      "info.user_id": "User ID",
      "info.username": "Username",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      offer_id: { label: "Offer", description: "Search by name" },
      user_id: { label: "Username", description: "Search by username" },
      category_id: { label: "Category" },
      name: { label: "Name", description: "Search by name" },
      country_code: { label: "Country" },
      status: { label: "Status", description: "Search by Status" },
    },
    formData: {
      offer_id: { label: "Offer" },
      name: { label: "Name" },
      category_id: { label: "Category" },
      country_code: { label: "Country" },
      status: { label: "Status" },
      redirect_url: { label: "Redirect URL" },
      download_url: { label: "Download URL" },
      user_id: { label: "User", description: "Search by username" },
    },
  },

  [moduleNames.ADMIN_LOGS_QUEUE_EMAIL]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Email queue",
    columns: {
      id: "ID",
      username: "Username",
      email: "Email",
      template: "Template",
      url: "URL",
      file: "File",
      status: "Status",
      executed: "Executed",
      created: "Created at",
    },
    filters: {
      template: {
        label: "Template",
        description: "Search by template",
      },
      email: {
        label: "Email",
        description: "Search by email",
      },
      username: {
        label: "Username",
        description: "Search by username",
      },
      status: {
        label: "Status",
        description: "Filter by status",
      },
    },
  },
  [moduleNames.ADMIN_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Orders",
    editLabel: "Edit",
    logsLabel: "Logs",
    editBulkLabel: "Edit",
    editModalTitle: "Edit order",
    editModalBulkTitle: "Edit orders",
    reqResModalTitle: "Req/Res Logs",
    columns: {
      "info.id": "ID",
      name: "Name",
      phone: "Phone",
      "offer.id": "Offer ID",
      "offer.name": "Offer name",
      "advertiser.offer_id": "Advertiser Offer ID",
      "info.advertiser_id": "Advertiser ID",
      "info.advertiser_username": "Advertiser",
      "info.status": "Status",
      "info.before_status": "Before status",
      "info.affiliate_id": "Affiliate ID",
      "info.affiliate_username": "Affiliate",
      "flow.landings.id": "Landings ID",
      "flow.landings.name": "Landings name",
      "flow.prelandings.id": "Prelandings ID",
      "flow.prelandings.name": "Prelandings name",
      country_code: "Country",
      quantity: "Quantity",
      "tracking.user_ip": "User IP",
      "created.timestamp": "Created",
      base_url: "Base URL",
      referrer: "Referrer",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "OS name",
      "tracking.os_version": "OS version",
      "tracking.browser_name": "Browser name",
      "tracking.browser_version": "Browser version",
      "tracking.safe_id": "Safe ID",
      "tracking.click_id": "Click ID",
      "tracking.device_type": "Device Type",
      "tracking.external_id": "External ID",
      "tracking.utm_term": "UTM Terms",
      "tracking.utm_medium": "UTM Medium",
      "tracking.utm_source": "UTM Source",
      "tracking.utm_content": "UTM content",
      "tracking.utm_campaign": "UTM campaign",
      "info.last_update": "Last update",
      "info.counter": "Counter",
      "info.comment": "Comment",
      test_mode: "Test mode",

    },
    filters: {
      id: { label: "ID" },

      affiliate_id: { label: "Aff. Id", description: "Search by Aff. Id" },
      affiliate_username: { label: "Aff. Username", description: "Search by Aff. Username" },
      affiliate_safe_id: { label: "Aff. SafeId", description: "Search by Aff. SafeId" },

      advertiser_id: { label: "Adv. Id", description: "Search by Adv. Id" },
      advertiser_username: { label: "Adv. Username", description: "Search by Adv. Username" },
      advertiser_safe_id: { label: "Adv. SafeId", description: "Search by Adv. SafeId" },

      country_code: { label: "Country", description: "Search by country name" },
      offer_id: { label: "Offer", description: "Search by offer name" },
      prelanding_id: { label: "Prelanding", description: "Search by name" },
      landing_id: { label: "Landings", description: "Search by name" },
      tracking_sub_1: { label: "Sub 1" },
      tracking_sub_2: { label: "Sub 2" },
      tracking_sub_3: { label: "Sub 3" },
      tracking_sub_4: { label: "Sub 4" },
      tracking_click_id: { label: "Tracking click ID" },
      name: { label: "Name" },
      external_id: { label: "External ID" },
      phone: { label: "Phone number" },
      status: { label: "Status" },
      date_range: { label: "Date range" },
    },
    formData: {
      country_code: { label: "Country", description: "Search by country name" },
      name: { label: "Name" },
      phone: { label: "Phone" },
      user_ip: { label: "User IP" },
      test_mode: { label: "Test mode" },
      advertiserOfferId: { label: "Advertiser Offer ID" },
      reset_counter: { label: "Reset counter" },
    },
  },
  [moduleNames.ADMIN_ORDERS_ERRORS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Order errors",
    editLabel: "Edit",
    deleteLabel: "Delete",
    resendLabel: "Resend",
    editBulkLabel: "Edit",
    deleteBulkLabel: "Delete",
    editModalTitle: "Edit order",
    deleteModalTitle: "Delete order",
    deleteModalBulkTitle: "Delete orders",
    editModalBulkTitle: "Edit orders",
    resendModalTitle: "Resend order",
    resendModalBody: "Are you sure you want to resend this order?",
    columns: {
      "info.id": "ID",
      name: "Name",
      phone: "Phone",
      "info.status": "Status",
      "info.attempts": "Attempts",
      error: "Error",
      offer_id: "Offer ID",
      base_url: "Base URL",
      api_key: "Api key",
      user_ip: "User IP",
      country_code: "Country",
      referrer: "Referrer",
      test_mode: "Test mode",
      os_name: "OS name",
      os_version: "OS version",
      browser_version: "Browser version",
      device_type: "Device Type",
      click_id: "Click ID",
      safe_id: "Safe ID",
      sub_1: "Sub 1",
      sub_2: "Sub 2",
      sub_3: "Sub 3",
      sub_4: "Sub 4",
      quantity: "Quantity",
      utm_term: "Utm term",
      utm_medium: "Utm medium",
      utm_source: "Utm source",
      utm_content: "Utm content",
      utm_campaign: "Utm campaign",
      "info.date": "Date",
      "info.timestamp": "Created",
    },
    filters: {
      name: { label: "Name" },
      api_key: { label: "Api key" },
      safe_id: { label: "Safe ID", description: "Search by safe ID" },
      user_ip: { label: "User IP", description: "Search by user's IP address" },
      offer_id: { label: "Offer", description: "Search by offer name" },
      country_code: { label: "Country", description: "Search by country name" },
      click_id: { label: "Click ID" },
      landings: { label: "Landing", description: "Search by landing name" },
      prelandings: { label: "Prelanding", description: "Search by name" },
    },
    formData: {
      name: { label: "Name", placeholder: "Name", description: "Edit name" },
      phone: {
        label: "Phone",
        placeholder: "Phone",
        description: "Edit phone",
      },
      apiKey: {
        label: "Api key",
        placeholder: "Api key",
        description: "Edit api key",
      },
      user_ip: {
        label: "User IP",
        placeholder: "IP",
        description: "Edit user IP address",
      },
      base_url: {
        label: "Base URL",
        placeholder: "Url",
        description: "Edit base url",
      },
      landings: {
        label: "Landings",
        placeholder: "Landings",
        description: "Select landing page",
      },
      offerId: {
        label: "Offer ID",
        placeholder: "Offer ID",
        description: "Search by offer id",
      },
      referrer: {
        label: "Referrer",
        placeholder: "Referrer",
        description: "Edit referrer link",
      },
      test_mode: {
        label: "Test mode",
        placeholder: "Test mode",
        description: "Select mode",
      },
      country_code: {
        label: "Country",
        placeholder: "Country name",
        description: "Search by country name",
      },
      safe_id: {
        label: "Safe ID",
        placeholder: "Safe ID",
        description: "Edit safe ID",
      },
    },
  },
  [moduleNames.ADMIN_PAYMENTS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Payments",
    createLabel: "Add payment",
    editLabel: "Edit",
    massRequestLabel: "Mass request",
    paymentLabel: "Set paid",
    editBulkLabel: "Edit",
    addModalTitle: "Create payment",
    editModalTitle: "Edit payment",
    paymentModalTitle: 'Set paid for',
    editModalBulkTitle: "Edit payments",
    paidConfirmationMessage: "Confirm if you want to set payment as paid?",
    massConfirmationMessage: "Are you sure you want to run mass payments?",
    massModalTitle: "Mass request",
    columns: {
      "info.id": "ID",
      "info.user_id": "User",
      "info.username": "Username",
      "username-id": "ID - username",
      "info.amount": "Amount",
      "data.method": "Method",
      "data.payment_settings_id.id": "Payment settings ID",
      "data.status": "Status",
      "data.description": "Description",
      "data.reject_comment": "Reject comment",
      "info.created_time": "Created at",
    },

    filters: {
      user_id: {
        label: "User",
        description: "Search by username",
      },
      method: {
        label: "Method",
        description: "Search by method",
      },
      status: {
        label: "Status",
        description: "Search by status",
      },
    },

    formData: {
      user_id: {
        label: "User",
        description: "Search by username",
      },
      amount: {
        label: "Amount",
        description: "Enter amount",
      },
      method: {
        label: "Method",
        description: "Select payment method",
      },
      status: {
        label: "Status",
        description: "Select status",
      },
      reject_comment: {
        label: "Reject comment",
        description: "Enter reject comment",
      },
      tracking_id: {
        label: "Tracking ID",
        description: "Enter tracking id",
      },
    },
  },
  [moduleNames.ADMIN_TOPUPS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Topups",
    createLabel: "Add topup",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create topup",
    editModalTitle: "Edit topup",
    editModalBulkTitle: "Edit topups",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete topup",
    deleteModalBulkTitle: "Delete topups",
    columns: {
      "info.id": "ID",
      "info.username": "Username",
      "data.orginal_amount": "Original amount",
      "data.amount": "Amount",
      "data.invoice_number": "Invoice number",
      "data.invoice_pdf": "Invoice PDF",
      "created.timestamp": "Created date",
      "created.date": "Created At",
      "info.advertiser_id": "Advertiser ID",
    },
    filters: {
      advertiser_id: { label: "Advertiser" },
      invoice_number: { label: "Invoice number" },
      amount: { label: "Amount" },
      orginal_amount: { label: "Orginal amount" },
    },
    formData: {
      advertiser_id: { label: "Advertiser" },
      amount: { label: "Amount" },
      original_amount: { label: "Original amount" },
      invoice_number: { label: "Invoice number" },
      invoicePdf: { label: "Invoice PDF" },
    },
  },
  [moduleNames.ADMIN_USERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Users",
    createLabel: "Add user",
    editLabel: "Edit",
    required: "Required*",
    info: "Info",
    message: "Message",
    social: "Social",
    company: "Company",
    paymentLabel: "Payment",
    authLabel: "Auth",
    permissionsLabel: "Permissions",
    deleteLabel: "Delete",
    editBulkLabel: "Edit",
    deleteBulkLabel: "Delete",
    createModalTitle: "Create user",
    editModalTitle: "Edit user",
    authModalTitle: "Edit user password",
    permissionModalTitle: "User permissions",
    deleteModalTitle: "Delete user",
    deleteModalBulkTitle: "Delete users",
    editModalBulkTitle: "Edit users",
    emailChangeConfirmation:
      "Changing the email will reset the account verification — a verification email will be sent to the new address and the user will have to verify the account again. Continue?",
    emailPermissionNote:
      "Changing the email address requires the \"Update email\" permission.",
    emailChangePermissionError:
      "You don't have permission to change the email address.",
    serverFieldErrors: {
      8: {
        email: "Invalid email address.",
        password: "Password must be between 12 and 128 characters.",
        repeated_password: "Passwords do not match.",
      },
      9: { email: "This email address is already used by another user." },
    },
    columns: {
      "info.id": "ID",
      "data.email": "Email",
      "data.username": "Username",
      "data.first_name": "First name",
      "data.last_name": "Last name",
      "data.status": "Status",
      "data.info.type": "Type",
      "data.info.is_active": "Active",
      "data.info.is_approved": "Approved",
      "data.info.trusted": "Trusted",
      "data.info.is_anonymous": "Anonymous",
      "data.info.is_worker": "Worker",
      "data.info.is_company": "Company",
      "data.info.token": "Token",
      "data.info.api_key": "Api key",
      "data.info.safe_id": "Safe ID",
      "data.info.comment": "Comment",
      "data.info.manager_id": "Manager ID",
      "info.manager_username": "Manager username",
      "data.ref_id": "Referral ID",
      "data.message.skype": "Skype",
      "data.message.telegram": "Telegram",
      "data.message.whatsapp": "Whatsapp",
      "data.social.google": "Google",
      "data.social.twiter": "Twitter",
      "data.social.facebook": "Facebook",
      "data.social.linkedin": "LinkedIn",
      "data.social.instagram": "Instagram",
      "data.company.name": "Company name",
      "data.company.email": "Company email",
      "data.company.city": "Company city",
      "data.company.zip": "Company zip",
      "data.company.country.code": "Company country",
      "data.company.address": "Company address",
      "data.company.tax": "Company tax",
      "edited.timestamp": "Edited",
      "edited.user.id": "Edited by",
      "edited.user.ip": "Edited from",
      "created.timestamp": "Created",
      "created.user.id": "Created by",
      "created.user.ip": "Created from",
      "info.refferal_username": "Referral",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      safe_id: { label: "Safe ID" },
      username: { label: "Username", description: "Search by username" },
      email: { label: "Email", description: "Search by email" },
      type: { label: "Type" },
      country_code: { label: "Country" },
      manager_id: { label: "Manager" },
      status: { label: "Status" },
      traffic_source: { label: "Traffic source" },
      message_skype: { label: "Skype" },
      message_telegram: { label: "Telegram" },
      message_whatsapp: { label: "Whatsapp" },
      api_key: { label: "Api key" },
    },
    formData: {
      username: { label: "Username" },
      firstName: { label: "First Name" },
      lastName: { label: "Last Name" },
      email: { label: "Email" },
      status: { label: "Status" },
      manager: { label: "Manager" },
      password: { label: "Password" },
      repeatPassword: { label: "Repeat Password" },
      comment: { label: "Comment" },
      type: { label: "Type" },
      country: { label: "Country", description: "Search by country name" },
      referral: { label: "Referral" },
      isActive: { label: "Active" },
      isApproved: { label: "Approved" },
      trusted: { label: "Trusted" },
      isAnonymous: { label: "Anonymous" },
      isWorker: { label: "Worker" },
      isCompany: { label: "Company" },
      skype: { label: "Skype" },
      telegram: { label: "Telegram" },
      whatsapp: { label: "Whatsapp" },
      google: { label: "Google" },
      twitter: { label: "Twitter" },
      facebook: { label: "Facebook" },
      linkedin: { label: "LinkedIn" },
      instagram: { label: "Instagram" },
      companyName: { label: "Name" },
      companyEmail: { label: "Email" },
      companyCity: { label: "City" },
      companyZip: { label: "ZIP" },
      companyCountry: {
        label: "Country",
        description: "Search by country name",
      },
      companyAddress: { label: "Address" },
      companyTax: { label: "Tax" },
      traffic_source: { label: "Traffic source" },

    },
  },
  [moduleNames.ADMIN_USERS_UNAPPROVED]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Unapproved users",
    approveLabel: "Approve",
    setManagerLabel: "Set manager",
    resetManagerLabel: "Reset manager",
    rejectLabel: "Reject",
    rejectBulkLabel: "Reject",
    rejectModalTitle: "Reject user",
    rejectModalBulkTitle: "Reject users",
    approveModalTitle: "Approve user",
    approveModalBody: "Are you sure you want to approve user?",
    setManagerModalTitle: "Set manager",
    setManagerModalBody: "Are you sure you want to set manager for user?",
    resetManagerModalTitle: "Reset manager",
    resetManagerModalBody: "Are you sure you want to reset manager for user?",
    columns: {
      "info.id": "ID",
      "data.email": "Email",
      "data.username": "Username",
      "data.first_name": "First name",
      "data.last_name": "Last name",
      "data.info.comment": "Comment",
      "data.message.skype": "Skype",
      "data.message.telegram": "Telegram",
      "data.message.whatsapp": "Whatsapp",
      "data.status": "Status",
      "data.info.type": "Type",
      "data.info.is_active": "Active",
      "data.info.is_approved": "Approved",
      "data.info.trusted": "Trusted",
      "data.info.is_anonymous": "Anonymous",
      "data.info.is_worker": "Worker",
      "data.info.is_company": "Company",
      "created.timestamp": "Created time",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      safe_id: { label: "Safe ID" },
      username: { label: "Username", description: "Search by username" },
      email: { label: "Email", description: "Search by username" },
      type: { label: "Type" },
      country_code: { label: "Country" },
      status: { label: "Status" },
    },
    formData: {
      rejectComment: { label: "Reject comment" },
    },
  },
  [moduleNames.ADMIN_POSTBACK_LOGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Postback logs",
    columns: {
      "info.id": "ID",
      "info.username": "Username",
      "data.offer.name": "Offer Name",
      "data.request_url": "Request URL",
      "data.status": "Status",
      "data.response_code": "Http Status",
      "data.offer_id": "Offer ID",
      "info.user_id": "User ID",
      "info.timestamp": "Timestamp",
    },

    filters: {
      id: {
        label: "ID",
        description: "Search by ID",
      },
      user_id: {
        label: "Username",
        description: "Search by username",
      },
      offer_id: {
        label: "Offer",
        description: "Search by offer",
      },
      response_code: {
        label: "Http Status",
        description: "Search by Http Status",
      },
      status: {
        label: "Status",
        description: "Search by status",
      },
      date_range: {
        label: "Date range",
        description: "Select date range",
      },
    },
  },
  [moduleNames.ADMIN_PROFILE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    serverFieldErrors: profileServerFieldErrors,
    browserTabTitle: "MonadLead - Profile",
    saveChanges: "Save changes",
    deleteSessionsTitle: "Delete sessions?",
    deleteSessionsDialog: "Are you sure you want to delete all sessions?",
    osName: "OS name",
    osTitle: "OS title",
    createdAt: "Created at",
    expires: "Expires",
    browserName: "Browser name",
    deviceType: "Device type",
    generalTitle: 'Profile general settings',
    changePasswordTitle: 'Profile auth settings',
    changePin: 'Profile PIN settings',
    messagesTitle: 'Profile instant messaging settings',
    companyTitle: 'Profile company settings',
    profileSettingsOptions: {
      general: "General",
      security: "Security",
      changePassword: "Change Password",
      changePin: "Change Pin",
      social: "Social",
      messages: "Messages",
      company: "Company",
      sessions: "Sessions",
      delete_session: "Delete session?",
      delete_confirmation: "Are you sure you want to delete this session",
      delete: "Delete",
      cancel: "Cancel",
    },
    helperText: {
      general:
        "To personalise your profile, write down your general personal information",
      security:
        "Manage your account security: change your password or PIN, and enable two-factor authentication.",
      changePassword:
        "If you've lost your password or wish to change it, fill out the form below by writing your new password and repeating it.",
      changePin:
        "After your session has expired, please use PIN instead of password for quick log in back. Change PIN using the form below.",
      social:
        "Paste down the links of social media profiles that you have been using currently.",
      messages:
        "Paste down the links of social media profiles that you have been using currently.",
      company:
        "To register your company, please provide correct general information.",
    },
    securitySettings: {
      passwordTitle: "Password",
      passwordDescription: "Change your account password.",
      pinTitle: "PIN",
      pinDescription: "Change the PIN used for quick re-login.",
      mfaTitle: "Two-factor authentication",
      mfaDescription: "Add an extra layer of protection by requiring a code from your authenticator app at sign-in.",
      mfaStatusEnabled: "Enabled",
      mfaStatusDisabled: "Disabled",
      mfaSetup: "Setup MFA",
      mfaManage: "Manage MFA",
      mfa: {
        titleSetup: "Set up two-factor authentication",
        titleEnabled: "Two-factor authentication",
        titleDisable: "Disable two-factor authentication",
        preparing: "Preparing your authenticator...",
        scanInstructions: "Scan the QR code with your authenticator app (Google Authenticator, Authy, 1Password) and enter the 6-digit code below.",
        manualEntry: "Manual entry key:",
        copy: "Copy",
        copied: "Copied",
        codeLabel: "Authenticator code",
        invalidCode: "Enter a valid 6-digit code",
        verifyAndEnable: "Verify & enable",
        enabledTitle: "Two-factor authentication is enabled",
        enabledDescription: "Your account is protected by an authenticator app.",
        disable: "Disable 2FA",
        disableInstructions: "Enter the current code from your authenticator app to disable 2FA.",
        back: "Back",
        cancel: "Cancel",
        close: "Close",
        genericError: "Something went wrong. Try again.",
      },
    },
    generalSettings: {
      firstName: { label: "First name" },
      lastName: { label: "Last name" },
      chooseCountry: { label: "Choose country" },
    },
    changePasswordSettings: {
      password: { label: "Password" },
      repeatPassword: { label: "Repeat password" },
    },
    changePinSettings: {
      pin: { label: "Pin" },
      repeatPin: { label: "Repeat pin" },
    },
    socialSettings: {
      facebook: {
        label: "Facebook profile link",
        placeholder: "Facebook profile link",
      },
      google: {
        label: "Google profile link",
        placeholder: "Google profile link",
      },
      twitter: {
        label: "Twitter profile link",
        placeholder: "Twitter profile link",
      },
      linkedin: {
        label: "Linkedin profile link",
        placeholder: "Linkedin profile link",
      },
      instagram: {
        label: "Instragram profile link",
        placeholder: "Instragram profile link",
      },
    },
    messageSettings: {
      skype: { label: "Skype", placeholder: "Skype profile link" },
      telegram: { label: "Telegram", placeholder: "Telegram" },
      whatsapp: { label: "Whatsapp", placeholder: "Whatsapp phone number" },
    },
    companySettings: {
      companyName: { label: "Company name", placeholder: "Company name" },
      country: { label: "Country", placeholder: "Select country" },
      city: { label: "City", placeholder: "City" },
      address: { label: "Address", placeholder: "Address" },
      zipCode: { label: "Zip code", placeholder: "ZIP code" },
      companyEmail: { label: "Company email", placeholder: "Company email" },
      tax: { label: "Tax", placeholder: "Tax" },
    },
    sessions: {
      setSessionExpirationTitle: "Set session expiration",
      expiration: {
        label: "Expiration",
        days: {
          oneDay: "1 day",
          sevenDays: "7 days",
          fifteenDays: "15 days",
          thirtyDays: "30 days",
          ninetyDays: "90 days",
        },
      },
      activeSessionsTitle: "Active Sessions",
      closeAllSessions: "Close all sessions",
    },
    formData: {
      firstName: { label: "First Name" },
      lastName: { label: "Last Name" },
      password: { label: "Password" },
      repeatPassword: { label: "Repeated Password" },
      pin: { label: "Pin" },
      repeated_pin: { label: "Repeated Pin" },
      country: {
        label: "Country",
        description: "Search by country name"
      },
      skype: { label: "Skype" },
      telegram: { label: "Telegram" },
      whatsapp: { label: "WhatsApp" },
      companyName: { label: "Name" },
      companyEmail: { label: "Email" },
      companyCity: { label: "City" },
      companyZip: { label: "ZIP" },
      companyAddress: { label: "Address" },
      companyTax: { label: "Tax" },
      companyCountry: {
        label: "Country",
        description: "Search by country name"
      },
    }

  },
  [moduleNames.ADMIN_FAQ]: {
    browserTabTitle: 'MonadLead - FAQ',
    title: 'Advice and answers from the MonadLead team',
    apiSettingsTitle: 'API Settings',
    apiSettingsSubtitle: 'Learn how to integrate your landing page with MonadLead',
    postbackSettingsTitle: 'Postback Settings',
    postbackSettingsSubtitle: 'Understand how to configure postbacks for conversions',
    introVideoTitle: 'Intro Video',
    introVideoSubtitle: 'Watch a quick introduction to our platform',
    videoNotSupported: 'Your browser does not support the video tag.',
    backToFaq: 'Back to FAQ',
    apiSettings: {
      question1: 'What are the required fields for API integration?',
      answer1: 'To properly connect your landing page to MonadLead via API, the following fields are mandatory:',
      question2: 'How do I connect my landing page to MonadLead via API?',
      answer2: `To connect your landing page to MonadLead via API, you can use the integration template file provided by your manager. Update the file with your API_KEY, configure the form to redirect to that file, and you're good to go.`,
      question3: 'How can I download landing pages from MonadLead?',
      answer3: 'You can download landing pages from the offer page by clicking the Download button on the card of the landing page you prefer.',
      question4: 'If I download a landing page from MonadLead, is it already configured?',
      answer4: 'Yes. When you download a landing page from MonadLead, all API settings are already configured, and your API_KEY is pre-filled. All you need to do is host it.',
    },
    postbackSettings: {
      question1: 'What macros are mandatory?',
      answer1: `There are no mandatory macros required by MonadLead. You configure macros based on your tracker's requirements and your own tracking needs.`,
      question2: 'What is a global vs. specific postback, and which should I choose?',
      answer2_1: 'A global postback is triggered every time its conditions are met, regardless of which offer the conversion came from.',
      answer2_2: 'A specific postback is tied to a particular offer and will only fire for that one.',
      answer2_3: 'Use a specific postback when you have special scenarios and want to send postbacks only for a single offer.',
      answer2_4: 'In all other cases, a global postback is recommended, as it works across all offers.',
    }
  },

  [moduleNames.AFFILIATE_DOMAINS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Domains",
    createLabel: "Add domain",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create domain",
    editModalTitle: "Edit domain",
    editModalBulkTitle: "Edit domains",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete domain",
    deleteModalBulkTitle: "Delete domains",
    contactSupport:
      "Please contact our support team, and they will provide you with the IP address for the A record.",
    columns: {
      "info.id": "ID",
      "data.domain": "Domain",
      "data.type": "Type",
      "data.status": "Status",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      status: { label: "Status", description: "Search by status" },
      type: { label: "Type", description: "Search by type" },
    },
    formData: {
      domain: {
        label: "Domain",
        description: "Enter domain name",
        placeholder: "Add domain",
      },
      type: {
        label: "Type",
        placeholder: "Tracking...",
        description: "Select domain type",
      },
      status: {
        label: "Status",
        placeholder: "Active...",
        description: "Set status",
      },
    },
  },
  [moduleNames.AFFILIATE_PAYMENTS_REQUEST]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Payment request",
    createLabel: "Request payment",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Request payment",
    editModalTitle: "Edit payment",
    editModalBulkTitle: "Edit payments",
    columns: {
      "info.id": "ID",
      "data.payment_setting_id": "Payment settings",
      "data.payment_settings_id": "Payment settings",
      "info.amount": "Amount",
      "data.method": "Method",
      "data.status": "Status",
      "data.description": "Description",
      "data.reject_comment": "Reject comment",
      "created.timestamp": "Created at",
      "created.user.id": "Created by",
      "created.user.ip": "Created from",
      "edited.timestamp": "Edited at",
      "edited.user.id": "Edited by",
      "edited.user.ip": "Edited from",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      status: { label: "Status" },
      method: { label: "Method" },
    },
    formData: {
      method: { label: "Method", placeholder: "Request Payment" },
      amount: { label: "Amount", placeholder: "" },
      payment_settings_id: { label: "Payment settings" },
    },
  },
  [moduleNames.AFFILIATE_PAYMENTS_SETTINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Payments settings",
    title: "Existing payment methods",
    createLabel: "Add new payment method",
    editLabel: "Edit",
    addModalTitle: "Create payment settings",
    editModalTitle: "Edit payment settings",
    deleteModalTitle: "Delete payment method?",
    deleteModalBody: "Are you sure you want to delete {name} ({method})? This action cannot be undone.",
    deleteSuccessMessage: "Payment method deleted",
    activateModalTitle: "Activate payment method",
    activateModalBody: "This action wil set payment method to status active",
    deactivateModalTitle: "Deactivate payment method",
    deactivateModalBody:
      "This action wil set payment method to status inactive",
    formData: {
      name: { label: "Name" },
      status: { label: "Status" },
      method: { label: "Method", placeholder: "Request Payment" },
      wallet: { label: "Wallet" },
    },
    confirmationModalTitle: 'Your payment method has been successfully saved',
    confirmationModalMessage: 'We’ve sent a confirmation email to your registered address. Please check your inbox and follow the instructions in the email to complete the process. If you do not see the email, be sure to check your spam or junk folder.',
  },
  [moduleNames.AFFILIATE_POSTBACK]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Postback",
    createLabel: "Add postback",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create postback",
    editModalTitle: "Edit postback",
    editModalBulkTitle: "Edit postbacks",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete postback",
    deleteModalBulkTitle: "Delete postbacks",
    enterUrl: "Enter URL",
    urlParams: "URL params",
    addParams: "Add params",
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.url": "Url",
      "data.level": "Level",
      "data.method": "Method",
      "data.event": "Event",
      "data.status": "Status",
      "data.offer.name": "Offer Name",
      "data.offer.id": "Offer ID",
      "data.user_id": "User ID",
    },
    filters: {
      offer_id: { label: "Offer", description: "Search by offer" },
      event: { label: "Event", description: "Search by event" },
      method: { label: "Method", description: "Search by method" },
      level: { label: "Level", description: "Search by level" },
    },
    formData: {
      method: {
        label: "Method",
        placeholder: "Method",
        description: "Select method",
        rules: {
          required: "required",
        },
      },
      name: {
        label: "Name",
        placeholder: "Name",
        description: "Enter name",
        rules: {
          required: "required",
        },
      },
      url: {
        label: "Url",
        placeholder: "https://domain.com/...",
        description: "Enter Url",
        rules: {
          required: "required",
        },
      },
      event: {
        label: "Event",
        placeholder: "Event",
        rules: {
          required: "required",
        },
      },
      level: {
        label: "Level",
        placeholder: "Level",
        description: "Select level",
        rules: {
          required: "required",
        },
      },
      status: {
        label: "Status",
        placeholder: "Status",
        rules: {
          required: "required",
        },
      },
      offer_id: {
        label: "Offer",
        description: "Search by offer name",
        rules: {
          required: "required",
        },
      },
    },
  },
  [moduleNames.AFFILIATE_POSTBACK_LOGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Postback logs",
    columns: {
      "info.id": "ID",
      "data.offer.name": "Offer Name",
      "data.request_url": "Request URL",
      "data.status": "Status",
      "data.response_code": "Http Status",
      "data.offer_id": "Offer ID",
      "info.timestamp": "Timestamp",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      offer_id: { label: "Offer", description: "Search by offer" },
      status: { label: "Status", description: "Search by status" },
      date_range: { label: "Date range" },
    },
  },

  [moduleNames.AFFILIATE_OFFERS_ALL]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    remove: "Remove from favorites",
    add: "Add to favorites",
    country: "Country",
    price: "Price",
    payout: "Payout",
    limit: "Limit",
    filter: "Filters",
    info: "Info",
    id: "ID",
    viewOfferLabel: "View offer",
    browserTabTitle: "MonadLead - All Offers",
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.access": "Access",
      "data.status": "Status",
      "data.paid_status": "Paid status",
      "data.info.ar": "Approve rate",
      "data.info.cr": "Conversion rate",
      "data.info.epc": "Earn per click",
      "data.advertiser.id": "Advertiser ID",
      "data.advertiser.name": "Advertiser",
      "data.advertiser.offer_id": "Advertiser offer ID",
      "data.category.id": "Category",
      "data.advertiser.expected_ar": "Expected aprove rate",
      "data.main_country_code": "Main country",
      "data.advertiser.advertiser_guarantees": "Advertiser guarantees",
      "data.advertiser.guaranteed_ar": "Guaranteed aprove rate",
      "data.advertiser.min_orders": "Guaranteed min orders",
      "data.advertiser.timeframe": "Guaranteed timeframe",
      "data.device": "Device",
      "data.vertical": "Vertical",
      "data.region": "Region",
      "data.flow": "Flow",
      "data.monadlead_tokens": "Monadlead tokens",
      "info.affiliate_payout": "Payout",
      "info.advertiser_cost": "Cost",
      "info.price": "Price"
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      name: { label: "Name" },
      advertiser_id: {
        label: "Advertiser ID",
        description: "Search by advertiser ID",
      },
      category_id: { label: "Category" },
      vertical: {
        label: "Vertical",
        description: "Select category"
      },
      region_id: { label: "Region" },
      is_favorite: {
        label: "Is Favourite",
        description: "Search by favourite",
      },
      access: { label: "Access" },
      paid_status: { label: "Paid status" },
      main_country_code: { label: "Main country" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_HOT]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Hot offers",
    removeFromFavorites: "Remove from favorites",
    addToFavorites: "Add to favorites",
    country: "Country",
    price: "Price",
    payout: "Payout",
    limit: "Limit",
    info: "Info",
    filters: {
      id: { label: "ID", description: "Search by ID" },
      name: { label: "Name" },
      paid_status: { label: "Paid status" },
      main_country_code: { label: "Main country" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_SINGLE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Single Offers",
    searchCountry: "Search for a country",
    info: "Info",
    id: "ID",
    sub_1: "Sub 1",
    sub_1_placeholder: "Enter sub 1",
    sub_2: "Sub 2",
    sub_2_placeholder: "Enter sub 2",
    sub_3: "Sub 3",
    sub_3_placeholder: "Enter sub 3",
    sub_4: "Sub 4",
    sub_4_placeholder: "Enter sub 4",
    enter_gtag: "Enter google tag",
    lp_required: "Landing page is required",
    gtag: "Google tag",
    enter_fb_pixel: "Enter Facebook pixel",
    fb_pixel: "Facebook pixel",
    body_params: "Request body params",
    example: "Request example",
    response_200: "Response code 200",
    response_400: "Response code 400",
    response_405: "Response code 405",
    response_406: "Response code 406",
    response_500: "Response code 500",
    plp: "Prelandings",
    lp: "Landings",
    conversion_rate: "Conversion rate",
    flow: "Flow",
    countries: "Countries",
    country: "Country",
    price: "Price",
    payout: "Payout",
    limit: "Limit",
    no_data: "No data",
    link_builder: "Link builder",
    form_builder: "Form builder",
    form_preview: "Form preview",
    api_request: "Api request",
    api_response: "Api response",
    request_vip: "Request VIP access",
    vip_message:
      "This is a VIP offer and you need to have access in order to advertise it.",
    request_message: "Please let us know why should we grant your request",
    request_access: "Request access",
    offer_url: "Offer URL",
    url_copied: "URL copied",
    pages: "Pages",
    copy: "Copy",
    no_prelanding: "No prelanding",
    type_comment: "Type in your comment",
    open_link: "Open in new tab",
    download_file: 'Download file',
    copyLink: "URL copied to clipboard",
    copyTooltip: "Copy URL",
    noTrackingLinks: "No tracking links",
  },
  [moduleNames.AFFILIATE_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Offers",
    filters: {
      id: { label: "ID", description: "Search by ID" },
      name: { label: "Name" },
      advertiser_id: {
        label: "Advertiser ID",
        description: "Search by advertiser ID",
      },
      category_id: { label: "Category" },
      is_favorite: {
        label: "Is Favourite",
        description: "Search by favourite",
      },
      access: { label: "Access" },
      paid_status: { label: "Paid status" },
      main_country_code: { label: "Main country" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_SUBSCRIPTIONS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Subscriptions",
    editLabel: "Edit",
    logsLabel: "Logs",
    editBulkLabel: "Edit",
    editModalTitle: "Edit order",
    editModalBulkTitle: "Edit orders",
    payments: "Payments",
    columns: {
      id: "ID",
      "affiliate.id": "Afiliate ID",
      "affiliate.name": "Afiliate",
      "offer.id": "Offer ID",
      "offer.name": "Offer name",
      "advertiser.id": "Advertiser ID",
      "tracking_link.name": "Tracking link",
      "tracking_link.id": "Tracking link ID",
      rev_share: "Rev share",
      subscriber: "Subscriber",
      status: "Status",
    },
    filters: {
      "offer.id": { label: "Offer", description: "Search by offer" },
      "affiliate.name": { label: "Afiliate", description: "Search by afiliate name" },
      "advertiser.id": { label: "Advertiser ID", description: "Search by advertiser id" },
      status: { label: "Status" },
    },
    formData: {
      rev_share: { label: "Rev share" },
      expiration_date: { label: "Expiration date" },
      status: { label: "Status" },
    },
  },
  [moduleNames.AFFILIATE_OFFERS_SUBSCRIPTIONS_PAYMENTS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    moduleTitle: "Payouts",
    createLabel: "Add payout",
    editLabel: "Edit",
    editBulkLabel: "Edit",
    addModalTitle: "Create payout",
    editModalTitle: "Edit payout",
    editModalBulkTitle: "Edit payouts",
    deleteLabel: "Delete",
    deleteBulkLabel: "Delete",
    deleteModalTitle: "Delete payout",
    deleteModalBulkTitle: "Delete payouts",
    columns: {
      description: 'Description',
      amount: 'Amount',
      rev_share: 'Rev share',
      status: 'Status',
    },
    filters: {
      status: { label: "Status" },
    },
    formData: {

    },
  },
  [moduleNames.AFFILIATE_DASHBOARD]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Dashboard",
    yesterday: "Yesterday",
    current_month: "Current month",
    last_month: "Last month",
    today: "Today",
    country: "Country",
    click: "Click",
    unique_click: "Unique click",
    revenue: "Revenue",
    conversion: "Conversion",
    conversion_rate: "Conversion rate",
    rate: "Conversion rate",
    cr: "CR",
    name: "Name",
    hold: "Hold",
    event: "Event",
    trash: "Trash",
    total: "Total",
    canceled: "Canceled",
    confirmed: "Confirmed",
    no_data: "No data",
    statistics: "Statistics",
    click_to_lp: "Click to LP",
    click_to_prelp: "Click to Prelp",
    date: "Date added",
    news: "News",
    switch_view: "Switch view",
    rangeShortcuts: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This week",
      lastWeek: "Last week",
      last7Days: "Last 7 days",
      currentMonth: "This month",
      lastMonth: "Last month",
      selectDate: "SELECT DATE RANGE",
      cancelButton: "Cancel",
      clearButton: "Clear",
      dateFrom: "Date from",
      dateTo: "End",
    },
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.download_url": "Download URL",
      "data.redirect_url": "Redirect URL",
      "data.status": "Status",
      "data.category.id": "Category",
      "data.category.name": "Category Name",
      "data.country_code": "Country",
      "info.offer_name": "Offer",
      "info.offer_id": "Offer ID",
      "info.country_name": "County Name",
      "info.user_id": "User ID",
      "info.username": "Username",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      offer_id: { label: "Offer", description: "Search by name" },
      user_id: { label: "Username", description: "Search by username" },
      category_id: { label: "Category" },
      name: { label: "Name", description: "Search by Name" },
      country_code: { label: "Country" },
      status: { label: "Status", description: "Search by status" },
    },
    formData: {
      offer_id: { label: "Offer" },
      name: { label: "Name" },
      category_id: { label: "Category" },
      country_code: { label: "Country" },
      status: { label: "Status" },
      redirect_url: { label: "Redirect URL" },
      download_url: { label: "Download URL" },
      user_id: { label: "User", description: "Search by username" },
    },
  },
  [moduleNames.AFFILIATE_REPORT]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Report",
    columns: {
      click: "Click",
      unique_click: "Unique clicks",
      click_to_prelp: "Click to prelp",
      click_to_lp: "Click to lp",
      total_hold: "Total",
      hold: "Hold",
      completed_hold: "Completed hold",
      conversion: "Conversion",
      conversion_rate: "CR",
      total_trash: "Trash",
      total_canceled: "Canceled",
      total_hold_revenue: "Total hold revenue",
      hold_revenue: "Hold revenue",
      revenue: "Revenue",
      total_trash_revenue: "Total trash revenue",
      total_canceled_revenue: "Total canceled revenue",
      revenue_per_click_hold: "Revenue per click - hold",
      revenue_per_click_conversion: "Revenue per click - conversion",
      revenue_per_unique_click_conversion:
        "Revenue per unique click - conversion",
      revenue_per_unique_click_hold: "Revenue per unique click - hold",
      events: "Events",
      utm_source: 'UTM Source',
      utm_medium: 'UTM Medium',
      utm_campaign: 'UTM Campaign',
      utm_term: 'UTM Term',
      utm_content: 'UTM Content',
    },
    filters: {
      stats_based_on: { label: "Group by" },
      offers: { label: "Offers", description: "Search by name" },
      click_id: { label: "Click ID" },
      landings: { label: "Landings" },
      prelandings: { label: "Prelandings" },
      country_code: { label: "Country" },
      user_id: { label: "User", description: "Search by username" },
      advertiser_id: { label: "Advertiser", description: "Search by username" },
      manager_id: { label: "Manager", description: "Search by username" },
      offer_id: { label: "Offer", description: "Search by name" },
      sub_1: { label: "Sub 1" },
      sub_2: { label: "Sub 2" },
      sub_3: { label: "Sub 3" },
      sub_4: { label: "Sub 4" },
      utm_campaign: { label: "UTM campaign", description: "Search by UTM campaign" },
      utm_content: { label: "UTM content", description: "Search by UTM content" },
      utm_medium: { label: "UTM medium", description: "Search by UTM medium" },
      utm_source: { label: "UTM source", description: "Search by UTM source" },
      utm_term: { label: "UTM term", description: "Search by UTM term" },
      date_range: { label: "Date range" },
    },
  },
  [moduleNames.AFFILIATE_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Orders",
    columns: {
      "info.id": "ID",
      name: "Name",
      phone: "Phone",
      "offer.id": "Offer ID",
      "offer.name": "Offer name",
      "info.status": "Status",
      "info.before_status": "Before status",
      "flow.landings.id": "Landings ID",
      "flow.landings.name": "Landings name",
      "flow.prelandings.id": "Prelandings ID",
      "flow.prelandings.name": "Prelandings name",
      country_code: "Country",
      quantity: "Quantity",
      "tracking.user_ip": "User IP",
      "created.timestamp": "Created",
      base_url: "Base URL",
      referrer: "Referrer",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "OS name",
      "tracking.os_version": "OS version",
      "tracking.browser_name": "Browser name",
      "tracking.browser_version": "Browser version",
      "tracking.safe_id": "Safe ID",
      "tracking.click_id": "Click ID",
      "tracking.device_type": "Device Type",
      "tracking.external_id": "External ID",
      "tracking.utm_term": "UTM Terms",
      "tracking.utm_medium": "UTM Medium",
      "tracking.utm_source": "UTM Source",
      "tracking.utm_content": "UTM content",
      "tracking.utm_campaign": "UTM campaign",
      "info.last_update": "Last update",
      "info.counter": "Counter",
      "info.comment": "Comment",
      test_mode: "Test mode",
    },
    filters: {
      id: { label: "ID" },
      country_code: { label: "Country", description: "Search by country name" },
      offer_id: { label: "Offer", description: "Search by offer" },
      sub_1: { label: "Sub 1", description: "Search by sub 1" },
      sub_2: { label: "Sub 2", description: "Search by sub 2" },
      sub_3: { label: "Sub 3", description: "Search by sub 3" },
      sub_4: { label: "Sub 4", description: "Search by sub 4" },
      click_id: { label: "Click ID", description: "Search by click id" },
      name: { label: "Name" },
      external_id: {
        label: "External ID",
        description: "Search by external id",
      },
      phone: { label: "Phone number" },
      status: { label: "Status" },
      prelanding_name: {
        label: "Prelanding",
        description: "Search by prelandings",
      },
      landing_name: { label: "Landing", description: "Search by landings" },
      date_range: { label: "Date range" },
    },
  },
  [moduleNames.AFFILIATE_BALANCE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Balance",
    columns: {
      "info.id": "ID",
      "data.offer_name": "Offer Name",
      "data.payout": "Payout",
      "data.click_id": "Click ID",
    },
    filters: {
      date_range: { label: "Date range" },
    },
  },
  [moduleNames.AFFILIATE_REFERRAL]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Referal",
    columns: {
      "info.id": "ID",
      "data.username": "Username",
      "data.first_name": "First Name",
      "data.last_name": "Last Name",
      "data.email": "Email",
      "data.is_active": "Is Active",
      "data.is_approved": "Is Approved",
    },
    filters: {
      username: { label: "Username", description: "Search by username" },
      email: { label: "Email" },
    },
  },
  [moduleNames.AFFILIATE_REFERRAL_STATS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Referal Stats",
    columns: {
      affiliate: "Affiliate",
      total: "Total",
      hold: "Hold",
      confirmed: "Confirmed",
      trash: "Trash",
      canceled: "Canceled",
      approve_rate: "Approve rate",
      trash_rate: "Trash rate",
      canceled_rate: "Canceled rate",
      payout: "Payout",
      profit: "Profit",
    },
    filters: {
      country_code: { label: "Country" },
      lp: { label: "Landing", description: "Search by name" },
      prelp: { label: "Prelanding", description: "Search by name" },
      sub_1: { label: "Sub 1" },
      sub_2: { label: "Sub 2" },
      sub_3: { label: "Sub 3" },
      sub_4: { label: "Sub 4" },
      date_range: { label: "Date range" },
    },
  },
  [moduleNames.AFFILIATE_LOGIN_HISTORY]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Login history",
    columns: {
      "info.id": "ID",
      ip: "IP",
      "info.username": "Username",
      country_code: "Country ",
      status: "Status",
      "data.os_type": "Device",
      "data.device_type": "Device Type",
      "data.os_title": "OS Title",
      "data.browser_title": "Browser Title",
      "data.os_name": "Operating System",
      "data.os_family": "OS Family",
      "data.os_version": "OS Version",
      "data.64bits_mode": "Bits Mode",
      "data.browser_name": "Browser",
      "data.browser_version": "Browser Version",
      "data.browser_ios_webview": "Browser IOS Webview",
      "data.browser_desktop_mode": "Browser Desktop Mode",
      "data.browser_gecko_version": "Browser Gecko Version",
      "data.browser_webkit_version": "Browser Webkit Version",
      "data.browser_android_webview": "Browser Android Version",
      "data.browser_chrome_original": "Browser Chrome Original",
      "data.browser_safari_original": "Browser Safari Original",
      "data.browser_chromium_version": "Browser Chromium Version",
      "data.browser_firefox_original": "Browser Firefox Original",
      "created.timestamp": "Created time",
    },
    filters: {
      ip: { label: "IP", description: "Search by IP" },
    },
  },
  [moduleNames.AFFILIATE_PROFILE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    serverFieldErrors: profileServerFieldErrors,
    browserTabTitle: "MonadLead - Profile",
    saveChanges: "Save changes",
    deleteSessionsTitle: "Delete sessions?",
    deleteSessionsDialog: "Are you sure you want to delete all sessions?",
    osName: "OS name",
    osTitle: "OS title",
    createdAt: "Created at",
    expires: "Expires",
    browserName: "Browser name",
    deviceType: "Device type",
    profileSettingsOptions: {
      general: "General",
      security: "Security",
      changePassword: "Change Password",
      changePin: "Change Pin",
      social: "Social",
      messages: "Messages",
      company: "Company",
      sessions: "Sessions",
      delete_session: "Delete session?",
      delete_confirmation: "Are you sure you want to delete this session",
      delete: "Delete",
      cancel: "Cancel",
    },
    helperText: {
      general:
        "To personalise your profile, write down your general personal information",
      security:
        "Manage your account security: change your password or PIN, and enable two-factor authentication.",
      changePassword:
        "If you've lost your password or wish to change it, fill out the form below by writing your new password and repeating it.",
      changePin:
        "After your session has expired, please use PIN instead of password for quick log in back. Change PIN using the form below.",
      social:
        "Paste down the links of social media profiles that you have been using currently.",
      messages:
        "Paste down the links of social media profiles that you have been using currently.",
      company:
        "To register your company, please provide correct general information.",
    },
    securitySettings: {
      passwordTitle: "Password",
      passwordDescription: "Change your account password.",
      pinTitle: "PIN",
      pinDescription: "Change the PIN used for quick re-login.",
      mfaTitle: "Two-factor authentication",
      mfaDescription: "Add an extra layer of protection by requiring a code from your authenticator app at sign-in.",
      mfaStatusEnabled: "Enabled",
      mfaStatusDisabled: "Disabled",
      mfaSetup: "Setup MFA",
      mfaManage: "Manage MFA",
      mfa: {
        titleSetup: "Set up two-factor authentication",
        titleEnabled: "Two-factor authentication",
        titleDisable: "Disable two-factor authentication",
        preparing: "Preparing your authenticator...",
        scanInstructions: "Scan the QR code with your authenticator app (Google Authenticator, Authy, 1Password) and enter the 6-digit code below.",
        manualEntry: "Manual entry key:",
        copy: "Copy",
        copied: "Copied",
        codeLabel: "Authenticator code",
        invalidCode: "Enter a valid 6-digit code",
        verifyAndEnable: "Verify & enable",
        enabledTitle: "Two-factor authentication is enabled",
        enabledDescription: "Your account is protected by an authenticator app.",
        disable: "Disable 2FA",
        disableInstructions: "Enter the current code from your authenticator app to disable 2FA.",
        back: "Back",
        cancel: "Cancel",
        close: "Close",
        genericError: "Something went wrong. Try again.",
      },
    },
    generalSettings: {
      firstName: { label: "First name" },
      lastName: { label: "Last name" },
      chooseCountry: { label: "Choose country", placeholder: "Choose country" },
    },
    changePasswordSettings: {
      password: { label: "Password" },
      repeatPassword: { label: "Repeat password" },
    },
    changePinSettings: {
      pin: { label: "Pin" },
      repeatPin: { label: "Repeat pin" },
    },
    socialSettings: {
      facebook: {
        label: "Facebook profile link",
        placeholder: "Facebook profile link",
      },
      google: {
        label: "Google profile link",
        placeholder: "Google profile link",
      },
      twitter: {
        label: "Twitter profile link",
        placeholder: "Twitter profile link",
      },
      linkedin: {
        label: "Linkedin profile link",
        placeholder: "Linkedin profile link",
      },
      instagram: {
        label: "Instragram profile link",
        placeholder: "Instragram profile link",
      },
    },
    messageSettings: {
      skype: { label: "Skype", placeholder: "Skype profile link" },
      telegram: { label: "Telegram", placeholder: "Telegram" },
      whatsapp: { label: "Whatsapp", placeholder: "Whatsapp phone number" },
    },
    companySettings: {
      companyName: { label: "Company name", placeholder: "Company name" },
      country: { label: "Country", placeholder: "Select country" },
      city: { label: "City", placeholder: "City" },
      address: { label: "Address", placeholder: "Address" },
      zipCode: { label: "Zip code", placeholder: "ZIP code" },
      companyEmail: { label: "Company email", placeholder: "Company email" },
      tax: { label: "Tax", placeholder: "Tax" },
    },
    sessions: {
      setSessionExpirationTitle: "Set session expiration",
      expiration: {
        label: "Expiration",
        days: {
          oneDay: "1 day",
          sevenDays: "7 days",
          fifteenDays: "15 days",
          thirtyDays: "30 days",
          ninetyDays: "90 days",
        },
      },
      activeSessionsTitle: "Active Sessions",
      closeAllSessions: "Close all sessions",
    },
  },
  [moduleNames.AFFILIATE_FAQ]: {
    browserTabTitle: 'MonadLead - FAQ',
    title: 'Advice and answers from the MonadLead team',
    apiSettingsTitle: 'API Settings',
    apiSettingsSubtitle: 'Learn how to integrate your landing page with MonadLead',
    postbackSettingsTitle: 'Postback Settings',
    postbackSettingsSubtitle: 'Understand how to configure postbacks for conversions',
    introVideoTitle: 'Intro Video',
    introVideoSubtitle: 'Watch a quick introduction to our platform',
    videoNotSupported: 'Your browser does not support the video tag.',
    backToFaq: 'Back to FAQ',
    apiSettings: {
      question1: 'What are the required fields for API integration?',
      answer1: 'To properly connect your landing page to MonadLead via API, the following fields are mandatory:',
      question2: 'How do I connect my landing page to MonadLead via API?',
      answer2: `To connect your landing page to MonadLead via API, you can use the integration template file provided by your manager. Update the file with your API_KEY, configure the form to redirect to that file, and you're good to go.`,
      question3: 'How can I download landing pages from MonadLead?',
      answer3: 'You can download landing pages from the offer page by clicking the Download button on the card of the landing page you prefer.',
      question4: 'If I download a landing page from MonadLead, is it already configured?',
      answer4: 'Yes. When you download a landing page from MonadLead, all API settings are already configured, and your API_KEY is pre-filled. All you need to do is host it.',
    },
    postbackSettings: {
      question1: 'What macros are mandatory?',
      answer1: `There are no mandatory macros required by MonadLead. You configure macros based on your tracker's requirements and your own tracking needs.`,
      question2: 'What is a global vs. specific postback, and which should I choose?',
      answer2_1: 'A global postback is triggered every time its conditions are met, regardless of which offer the conversion came from.',
      answer2_2: 'A specific postback is tied to a particular offer and will only fire for that one.',
      answer2_3: 'Use a specific postback when you have special scenarios and want to send postbacks only for a single offer.',
      answer2_4: 'In all other cases, a global postback is recommended, as it works across all offers.',
    }
  },

  [moduleNames.ADVERTISER_OFFERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Offers",
    viewLandingsLabel: "Landings",
    viewPrelandingsLabel: "Prelandings",
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.access": "Access",
      "data.status": "Status",
      "data.paid_status": "Paid status",
      "data.info.ar": "Approve rate",
      "data.info.cr": "Conversion rate",
      "data.info.epc": "Earn per click",
      "data.advertiser.id": "Advertiser ID",
      "data.advertiser.name": "Advertiser",
      "data.advertiser.offer_id": "Advertiser offer ID",
      "data.category.id": "Category ",
      "data.advertiser.expected_ar": "Expected approve rate",
      "data.main_country_code": "Main country",
      "data.advertiser.advertiser_guarantees": "Advertiser guarantees",
      "data.device": "Device",
      "data.vertical": "Vertical",
      "data.region": "Region",
      "data.flow": "Flow",
      "data.charge": "Charge",
      "data.category.name": "Category name",
      "data.advertiser.guaranteed_ar": "Guaranteed approve rate",
      "data.description": "Description",
    },
    filters: {
      id: { label: "Name", description: "Search by name" },
      category_name: { label: "Category", description: "Search by category" },
      category_id: { label: "Category" },
      vertical_id: { label: "Vertical" },
      status: { label: "Status" },
      access: { label: "Access", description: "Search by access" },
      paid_status: { label: "Paid status" },
      main_country_code: { label: "Main country" },
    },
    formData: {
      category1Vertical: { label: "category1Vertical" },
      category2Vertical: { label: "category2Vertical" },
      category3Vertical: { label: "category3Vertical" },
      category4Vertical: { label: "category4Vertical" },
      category1Flow: { label: "category1Flow" },
      category2Flow: { label: "category2Flow" },
      category3Flow: { label: "category3Flow" },
      category4Flow: { label: "category4Flow" },
    },
  },
  [moduleNames.ADVERTISER_LANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Landings",
    moduleTitle: "Landings",
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.download_url": "Download URL",
      "data.redirect_url": "Redirect URL",
      "data.status": "Status",
      "data.category.id": "Category",
      "data.category.name": "Category Name",
      "data.country_code": "Country",
      "info.offer_name": "Offer name",
      "info.offer_id": "Offer ID",
      "info.country_name": "Country name",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      status: { label: "Status", description: "Search by status" },
      name: { label: "Name", description: "Search by name" },
    },
  },
  [moduleNames.ADVERTISER_PRELANDINGS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Preandings",
    moduleTitle: "Prelandings",
    columns: {
      "info.id": "ID",
      "data.name": "Name",
      "data.download_url": "Download URL",
      "data.redirect_url": "Redirect URL",
      "data.status": "Status",
      "data.category.id": "Category",
      "data.category.name": "Category Name",
      "data.country_code": "Country",
      "info.offer_name": "Offer",
      "info.offer_id": "Offer ID",
      "info.country_name": "Country Name",
    },
    filters: {
      id: { label: "ID", description: "Search by ID" },
      status: { label: "Status", description: "Search by status" },
      name: { label: "Name", description: "Search by name" },
    },
  },
  [moduleNames.ADVERTISER_DASHBOARD]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Dashboard",
    cost: "Cost",
    conversion: "Conversion",
    conversion_rate: "Conversion rate",
    hold: "Hold",
    canceled: "Canceled",
    trash: "Trash",
    statistics: "Statistics",
    rangeShortcuts: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This week",
      lastWeek: "Last week",
      last7Days: "Last 7 days",
      currentMonth: "This month",
      lastMonth: "Last month",
      selectDate: "SELECT DATE RANGE",
      cancelButton: "Cancel",
      clearButton: "Clear",
      dateFrom: "Date from",
      dateTo: "End",
    },
    card: {
      today: "Today",
      yesterday: "Yesterday",
      currentMonth: "Current month",
      lastMonth: "Last month",
    },
  },
  [moduleNames.ADVERTISER_ORDERS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Orders",
    columns: {
      "info.id": "ID",
      name: "Name",
      phone: "Phone",
      "offer.id": "Offer ID",
      "offer.name": "Offer name",
      "advertiser.offer_id": "Advertiser Offer ID",
      "info.status": "Status",
      "info.before_status": "Before status",
      "flow.landings.id": "Landings ID",
      "flow.landings.name": "Landings name",
      "flow.prelandings.id": "Prelandings ID",
      "flow.prelandings.name": "Prelandings name",
      country_code: "Country",
      quantity: "Quantity",
      "tracking.user_ip": "User IP",
      "created.timestamp": "Created",
      base_url: "Base URL",
      referrer: "Referrer",
      "tracking.sub_1": "Sub 1",
      "tracking.sub_2": "Sub 2",
      "tracking.sub_3": "Sub 3",
      "tracking.sub_4": "Sub 4",
      "tracking.os_name": "OS name",
      "tracking.os_version": "OS version",
      "tracking.browser_name": "Browser name",
      "tracking.browser_version": "Browser version",
      "tracking.safe_id": "Safe ID",
      "tracking.click_id": "Click ID",
      "tracking.device_type": "Device Type",
      "tracking.external_id": "External ID",
      "tracking.utm_term": "UTM Terms",
      "tracking.utm_medium": "UTM Medium",
      "tracking.utm_source": "UTM Source",
      "tracking.utm_content": "UTM content",
      "tracking.utm_campaign": "UTM campaign",
      "info.last_update": "Last update",
      "info.counter": "Counter",
      test_mode: "Test mode",
    },
    filters: {
      name: { label: "Name", description: "Search by name" },
      country_code: { label: "Country", description: "Search by country" },
      offer_id: { label: "Offer", description: "Search by offer id" },
      prelanding_id: {
        label: "Prelanding",
        description: "Search by prelanding ",
      },
      landing_id: { label: "Landing ", description: "Search by landing" },
      sub_1: { label: "Sub 1", description: "Search by sub 1" },
      sub_2: { label: "Sub 2", description: "Search by sub 2" },
      sub_3: { label: "Sub 3", description: "Search by sub 3" },
      sub_4: { label: "Sub 4", description: "Search by sub 4" },
      tracking_click_id: {
        label: "Tracking click id",
        description: "Search by tracking clikc id",
      },
      external_id: {
        label: "External ID",
        description: "Search by external id",
      },
      phone: { label: "Phone", description: "Search by phone " },
      status: { label: "Status", description: "Search by status" },
    },
  },
  [moduleNames.ADVERTISER_TOPUPS]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Topups",
    columns: {
      "info.id": "ID",
      "info.username": "Username",
      "data.orginal_amount": "Original amount",
      "data.amount": "Amount",
      "data.invoice_number": "Invoice number",
      "data.invoice_pdf": "Invoice PDF",
      "created.timestamp": "Created date",
      "created.date": "Created At",
      "info.advertiser_id": "Advertiser ID",
    },
    filters: {
      invoice_number: { label: "Invoice number" },
      amount: { label: "Amount" },
      orginal_amount: { label: "Original amount" },
    },
  },
  [moduleNames.ADVERTISER_LOGIN_HISTORY]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    browserTabTitle: "MonadLead - Login history",
    columns: {
      "info.id": "ID",
      ip: "IP",
      "info.username": "Username",
      country_code: "Country ",
      status: "Status",
      "data.os_type": "Device",
      "data.device_type": "Device Type",
      "data.os_title": "OS Title",
      "data.browser_title": "Browser Title",
      "data.os_name": "Operating System",
      "data.os_family": "OS Family",
      "data.os_version": "OS Version",
      "data.64bits_mode": "Bits Mode",
      "data.browser_name": "Browser",
      "data.browser_version": "Browser Version",
      "data.browser_ios_webview": "Browser IOS Webview",
      "data.browser_desktop_mode": "Browser Desktop Mode",
      "data.browser_gecko_version": "Browser Gecko Version",
      "data.browser_webkit_version": "Browser Webkit Version",
      "data.browser_android_webview": "Browser Android Version",
      "data.browser_chrome_original": "Browser Chrome Original",
      "data.browser_safari_original": "Browser Safari Original",
      "data.browser_chromium_version": "Browser Chromium Version",
      "data.browser_firefox_original": "Browser Firefox Original",
      "created.timestamp": "Created time",
    },
  },
  [moduleNames.ADVERTISER_PROFILE]: {
    enumTranslations,
    commonTableFilters,
    commonModalTranslations,
    commonTableTranslations,
    serverFieldErrors: profileServerFieldErrors,
    browserTabTitle: "MonadLead - Profile",
    saveChanges: "Save changes",
    deleteSessionsTitle: "Delete sessions?",
    deleteSessionsDialog: "Are you sure you want to delete all sessions?",
    osName: "OS name",
    osTitle: "OS title",
    createdAt: "Created at",
    expires: "Expires",
    browserName: "Browser name",
    deviceType: "Device type",
    profileSettingsOptions: {
      general: "General",
      security: "Security",
      changePassword: "Change Password",
      changePin: "Change Pin",
      social: "Social",
      messages: "Messages",
      company: "Company",
      sessions: "Sessions",
      delete_session: "Delete session?",
      delete_confirmation: "Are you sure you want to delete this session",
      delete: "Delete",
      cancel: "Cancel",
    },
    helperText: {
      general:
        "To personalise your profile, write down your general personal information",
      security:
        "Manage your account security: change your password or PIN, and enable two-factor authentication.",
      changePassword:
        "If you've lost your password or wish to change it, fill out the form below by writing your new password and repeating it.",
      changePin:
        "After your session has expired, please use PIN instead of password for quick log in back. Change PIN using the form below.",
      social:
        "Paste down the links of social media profiles that you have been using currently.",
      messages:
        "Paste down the links of social media profiles that you have been using currently.",
      company:
        "To register your company, please provide correct general information.",
    },
    securitySettings: {
      passwordTitle: "Password",
      passwordDescription: "Change your account password.",
      pinTitle: "PIN",
      pinDescription: "Change the PIN used for quick re-login.",
      mfaTitle: "Two-factor authentication",
      mfaDescription: "Add an extra layer of protection by requiring a code from your authenticator app at sign-in.",
      mfaStatusEnabled: "Enabled",
      mfaStatusDisabled: "Disabled",
      mfaSetup: "Setup MFA",
      mfaManage: "Manage MFA",
      mfa: {
        titleSetup: "Set up two-factor authentication",
        titleEnabled: "Two-factor authentication",
        titleDisable: "Disable two-factor authentication",
        preparing: "Preparing your authenticator...",
        scanInstructions: "Scan the QR code with your authenticator app (Google Authenticator, Authy, 1Password) and enter the 6-digit code below.",
        manualEntry: "Manual entry key:",
        copy: "Copy",
        copied: "Copied",
        codeLabel: "Authenticator code",
        invalidCode: "Enter a valid 6-digit code",
        verifyAndEnable: "Verify & enable",
        enabledTitle: "Two-factor authentication is enabled",
        enabledDescription: "Your account is protected by an authenticator app.",
        disable: "Disable 2FA",
        disableInstructions: "Enter the current code from your authenticator app to disable 2FA.",
        back: "Back",
        cancel: "Cancel",
        close: "Close",
        genericError: "Something went wrong. Try again.",
      },
    },
    generalSettings: {
      firstName: { label: "First name" },
      lastName: { label: "Last name" },
      chooseCountry: { label: "Choose country", placeholder: "Choose country" },
    },
    changePasswordSettings: {
      password: { label: "Password" },
      repeatPassword: { label: "Repeat password" },
    },
    changePinSettings: {
      pin: { label: "Pin" },
      repeatPin: { label: "Repeat pin" },
    },
    socialSettings: {
      facebook: {
        label: "Facebook profile link",
        placeholder: "Facebook profile link",
      },
      google: {
        label: "Google profile link",
        placeholder: "Google profile link",
      },
      twitter: {
        label: "Twitter profile link",
        placeholder: "Twitter profile link",
      },
      linkedin: {
        label: "Linkedin profile link",
        placeholder: "Linkedin profile link",
      },
      instagram: {
        label: "Instragram profile link",
        placeholder: "Instragram profile link",
      },
    },
    messageSettings: {
      skype: { label: "Skype", placeholder: "Skype profile link" },
      telegram: { label: "Telegram", placeholder: "Telegram" },
      whatsapp: { label: "Whatsapp", placeholder: "Whatsapp phone number" },
    },
    companySettings: {
      companyName: { label: "Company name", placeholder: "Company name" },
      country: { label: "Country", placeholder: "Select country" },
      city: { label: "City", placeholder: "City" },
      address: { label: "Address", placeholder: "Address" },
      zipCode: { label: "Zip code", placeholder: "ZIP code" },
      companyEmail: { label: "Company email", placeholder: "Company email" },
      tax: { label: "Tax", placeholder: "Tax" },
    },
    sessions: {
      setSessionExpirationTitle: "Set session expiration",
      expiration: {
        label: "Expiration",
        days: {
          oneDay: "1 day",
          sevenDays: "7 days",
          fifteenDays: "15 days",
          thirtyDays: "30 days",
          ninetyDays: "90 days",
        },
      },
      activeSessionsTitle: "Active Sessions",
      closeAllSessions: "Close all sessions",
    },
  },
  [moduleNames.ADVERTISER_FAQ]: {
    browserTabTitle: 'MonadLead - FAQ',
    title: 'Advice and answers from the MonadLead team',
    apiSettingsTitle: 'API Settings',
    apiSettingsSubtitle: 'Learn how to integrate your landing page with MonadLead',
    postbackSettingsTitle: 'Postback Settings',
    postbackSettingsSubtitle: 'Understand how to configure postbacks for conversions',
    introVideoTitle: 'Intro Video',
    introVideoSubtitle: 'Watch a quick introduction to our platform',
    videoNotSupported: 'Your browser does not support the video tag.',
    backToFaq: 'Back to FAQ',
    apiSettings: {
      question1: 'What are the required fields for API integration?',
      answer1: 'To properly connect your landing page to MonadLead via API, the following fields are mandatory:',
      question2: 'How do I connect my landing page to MonadLead via API?',
      answer2: `To connect your landing page to MonadLead via API, you can use the integration template file provided by your manager. Update the file with your API_KEY, configure the form to redirect to that file, and you're good to go.`,
      question3: 'How can I download landing pages from MonadLead?',
      answer3: 'You can download landing pages from the offer page by clicking the Download button on the card of the landing page you prefer.',
      question4: 'If I download a landing page from MonadLead, is it already configured?',
      answer4: 'Yes. When you download a landing page from MonadLead, all API settings are already configured, and your API_KEY is pre-filled. All you need to do is host it.',
    },
    postbackSettings: {
      question1: 'What macros are mandatory?',
      answer1: `There are no mandatory macros required by MonadLead. You configure macros based on your tracker's requirements and your own tracking needs.`,
      question2: 'What is a global vs. specific postback, and which should I choose?',
      answer2_1: 'A global postback is triggered every time its conditions are met, regardless of which offer the conversion came from.',
      answer2_2: 'A specific postback is tied to a particular offer and will only fire for that one.',
      answer2_3: 'Use a specific postback when you have special scenarios and want to send postbacks only for a single offer.',
      answer2_4: 'In all other cases, a global postback is recommended, as it works across all offers.',
    }
  }
};

export default GB;
